<template>
  <span class="bodyed">
    <div class="time" >{{timed}}</div>
    <div class="viewport">
      <div class="column">
        <!--概览-->
        <div class="overview ">
          <div class="inner">
            <div class="item panel_box">
              <span>设备总数</span>
              <h4>5622台</h4>
            </div>
            <div class="item panel_box">
              <span>设备在线数</span>
              <h4>5622台</h4>
            </div>
            <div class="item panel_box">
              <span>实时功率</span>
              <h4>
                6886774kW</h4>
            </div>
          </div>
        </div>
        <!--设备状态分析-->
        <div class="users panel">
          <div class="inner">
            <h3>设备状态分析</h3>
            <div class="chart">
              <vchart style="height: 100%;" ref='vchart1'></vchart>
            </div>
          </div>
        </div>

        <!-- 分项能耗分布 -->
        <div class="sales panel">
          <div class="inner">
            <h3>分项能耗分布</h3>
            <div class="chart">
              <vchart style="height: 100%;" ref='vchart3'></vchart>
            </div>
          </div>
        </div>

      </div>
      <div class="column">
        <!-- 地图 -->
        <div class="map">
          <h3>
            <span class="fa fa-cube"></span>
            设备数据统计
          </h3>
          <div class="chart">
            <vchart class="geo" style="height: 100%;" ref='vchart6'></vchart>
          </div>
        </div>

      </div>
      <div class="column">
        <!-- 订单 -->
        <div class="overview ">
          <div class="inner">
            <div class="item panel_box">
              <span>当日能耗</span>
              <h4>78967kWh</h4>
            </div>
            <div class="item panel_box">
              <span>碳排放量</span>
              <h4>767833kgco2</h4>
            </div>
            <div class="item panel_box">
              <span>环比上升</span>
              <h4>8%</h4>
            </div>
          </div>
        </div>


        <!--设备统计分析-->
        <div class="point panel">
          <div class="inner" style="padding-left: 0;padding-right: 0;">
            <h3>设备统计分析</h3>
            <div class="chart" style="flex: 1;">
              <vchart style="height: 100%;" ref='vchart2'></vchart>

            </div>
          </div>
        </div>

        <!-- 实时事件 -->
        <div class="monitor panel">
          <div class="inner">
            <h3>实时事件</h3>
            <div class="content" style="display: block;">

              <div class="marquee-view">
                <div class="marquee">
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>
                  <div class="row">
                    <span class="col">能耗超额</span>
                    <span class="col">滨海楼 1#冷冻水塔 累计能耗达8978kwh</span>
                    <span class="col">一分钟前</span>
                    <span class="icon-dot"></span>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>
    <!-- 工单状态 -->
    <span class="bottom_box">
      <div class="users panel" style="min-height: 230px;">
        <div class="inner">
          <h3>工单状态</h3>
          <div class="chart chart_box">
            <vchart style="height: 100%;" ref='vchart4'></vchart>
            <div class="progress">
              <div class="text"><span>当日新增任务数</span> <span>60条</span></div>
              <el-progress :text-inside="true"  :stroke-width="17" :percentage="70"></el-progress> 
              <div class="text"><span>当日完成数</span> <span>5条</span></div>
              <el-progress :text-inside="true"  :stroke-width="17" :percentage="70"></el-progress>
            </div>

          </div>
        </div>
      </div>
      <div class="users panel" style="min-height: 230px;">
        <div class="inner">  
          <h3>事件分布</h3>
          <div class="chart chart_box">
            <vchart style="height: 100%;" ref='vchart5'></vchart>
            <div class="progress2">
              <div class="text"><span>事件类型一</span> <span>60条</span></div>
              <el-progress :text-inside="true" :stroke-width="17" :percentage="70"></el-progress>
              <div class="text"><span>事件类型二</span> <span>5条</span></div>
              <el-progress :text-inside="true" :stroke-width="17" :percentage="70"></el-progress>
              <div class="text"><span>事件类型三</span> <span>60条</span></div>
              <el-progress :text-inside="true" :stroke-width="17" :percentage="70"></el-progress>
              <div class="text"><span>事件类型四</span> <span>5条</span></div>
              <el-progress :text-inside="true" :stroke-width="17" :percentage="70"></el-progress>
            </div>

          </div>
        </div>
      </div>
    </span>
  </span>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart
    },
    data() {
      return {
        timed: '',
      }
    },
    mounted() {
      var url = encodeURI("http://wthrcdn.etouch.cn/weather_mini?city=珠海市");
      $.get({
        url: url,
        dataType: "json",
        async: false,
        success: (data) => {
          var d = data.data.forecast[0];
          this.timed = this.parseTime(new Date(), '{y}年{m}-{d} ') + d.type + ', ' + d.high.slice(3, 5) + '~' + d.low.slice(-3);

        }
      })
      // "高温 27℃" slice(), d
      //滚动
      //原理：把marquee下面的子盒子都复制一遍 加入到marquee中
      //      然后动画向上滚动，滚动到一半重新开始滚动
      //因为选取的是两个marquee  所以要遍历
      $('.monitor .marquee').each(function (index, dom) {
        //将每个 的所有子级都复制一遍
        var rows = $(dom).children().clone();
        //再将新的到的加入原来的
        $(dom).append(rows);
      });

      // 点位分布统计
      this.fenbu();

      // 设备状态分析
      this.yonghu();

      // 定单
      this.dingdan();

      // 分项能耗分布
      this.xiaoshou();

      //工作状态
      this.workStatus();

      //事件分布
      this.distribution();
      this.map();
    },
    methods: {
      parseTime(time, cFormat) {
        if (arguments.length === 0) {
          return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
          }
          if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
          }
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
          const value = formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
          return value.toString().padStart(2, '0')
        })
        return time_str
      },
      // 设备状态分析
      yonghu() {
        // 中间省略的数据  准备三项
        var item = {
          name: '',
          value: 1200,
          // 柱子颜色
          itemStyle: {
            color: '#254065'
          },
          // 鼠标经过柱子颜色
          emphasis: {
            itemStyle: {
              color: '#254065'
            }
          },
          // 工具提示隐藏
          tooltip: {
            extraCssText: 'opacity:0'
          }
        };
        var option = {
          // 工具提示
          tooltip: {
            // 触发类型  经过轴触发axis  经过轴触发item
            trigger: 'item',
            // 轴触发提示才有效
            axisPointer: {
              // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果       
              type: 'shadow'
            }
          },
          // 图表边界控制
          grid: {
            // 距离 上右下左 的距离
            left: '0',
            right: '3%',
            bottom: '3%',
            top: '5%',
            // 大小是否包含文本【类似于boxsizing】
            containLabel: true,
            //显示边框
            show: true,
            //边框颜色
            borderColor: 'rgba(0, 240, 255, 0.3)'
          },
          // 控制x轴
          xAxis: [
            {
              // 使用类目，必须有data属性
              type: 'value',
              // 使用 data 中的数据设为刻度文字

              // 刻度设置
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: false,
                show: false
              },
              //文字
              axisLabel: {
                color: '#4c9bfd'
              }
            }
          ],
          // 控制y轴
          yAxis: [
            {
              data: ['故障数', '停止运行数', '正常运行数'],
              // 使用数据的值设为刻度文字
              type: 'category',
              axisTick: {
                // true意思：图形在刻度中间
                // false意思：图形在刻度之间
                alignWithLabel: false,
                show: false
              },
              //文字
              axisLabel: {
                color: '#4c9bfd'
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(0, 240, 255, 0.3)'
                }
              },
            }
          ],
          // 控制x轴
          series: [

            {
              // series配置
              // 颜色
              itemStyle: {
                // 提供的工具函数生成渐变颜色
                color: new echarts.graphic.LinearGradient(
                  // (x1,y2) 点到点 (x2,y2) 之间进行渐变
                  0, 0, 0, 1,
                  [
                    { offset: 0, color: '#00fffb' }, // 0 起始颜色
                    { offset: 1, color: '#0061ce' }  // 1 结束颜色
                  ]
                )
              },
              // 图表数据名称
              name: '用户统计',
              // 图表类型
              type: 'bar',
              // 柱子宽度
              barWidth: '60%',
              // 数据
              data: [9, 7, 7]
            }
          ]
        };

        this.$refs.vchart1.setData(option, true);


      },
      // 设备统计分析
      fenbu() {


        var option = {

          tooltip: {
            trigger: 'item',
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "%";
            },
          },
          legend: {
            bottom: '1%',
            left: 'center',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#fff'//字体颜色
            },

          },
          color: ["#427dfa", "#05c2f7", "#f29d65", "#db626a"],
          series: [
            {
              name: "设备统计分析",
              type: 'pie',
              radius: ['35%', '60%'],
              center: ['51%', '40%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#101129',
                borderWidth: 2
              },
              label: { 
              },
              emphasis: {
                label: {
                  show: true,
                  formatter: '{b}:{d}%',
                  fontSize: '16',

                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: 32.26, name: '照明设备' },
                { value: 25.09, name: '排水设备' },
                { value: 24.73, name: '空调设备' },
                { value: 17.92, name: '通风设备' }
              ]
            }
          ]
        };
        this.$refs.vchart2.setData(option, true);
      },

      // 定单
      dingdan() {
        var data = {
          day365: { orders: '20,301,987', amount: '99834' },
          day90: { orders: '301,987', amount: '9834' },
          day30: { orders: '1,987', amount: '3834' },
          day1: { orders: '987', amount: '834' }
        }
        //点击事件
        $('.order').on('click', '.filter a', function () {
          //点击之后加类名
          $(this).addClass('active').siblings().removeClass('active');
          // 先获取点击a的 data-key自定义属性
          var key = $(this).attr('data-key');
          //获取自定义属性
          // data{}==>data.shuxing data['shuxing]
          key = data[key];//
          $('.order .item h4:eq(0)').text(key.orders);
          $('.order .item h4:eq(1)').text(key.amount);
        });
        //定时器
        var index = 0;
        var aclick = $('.order a');
        setInterval(function () {
          index++;
          if (index > 3) {
            index = 0;
          }
          //每san秒调用点击事件
          aclick.eq(index).click();
        }, 3000);
      },
      //分项能耗分布
      xiaoshou() {
        var option = {
          tooltip: {
            trigger: "item",
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "%";
            },
          },
          legend: {
            bottom: '1%',
            left: 'center',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#fff'//字体颜色
            },

          },

          color: ["#427dfa", "#05c2f7", "#f29d65", "#db626a"],
          series: [
            {
              name: "分项能耗分布",
              type: "pie",
              radius: "60%",
              center: ["50%", "38%"],

              itemStyle: {
                borderColor: "#101129",
                borderWidth: 1,
              },
              label: { 
              },

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                label: {
                  show: true,
                  formatter: '{b}:{d}%',
                  fontSize: '16',
                }
              },
              data: [
                { value: 21.68, name: "其他设备" },
                { value: 10.62, name: "动力设备" },
                { value: 25.33, name: "空调设备" },
                { value: 32.28, name: "照明设备" },
              ],

            },
          ],
        };
        this.$refs.vchart3.setData(option, true);
      },
      //工作状态
      workStatus() {
        var option = {
          tooltip: {
            trigger: "item",
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "%";
            },
          },
          legend: {
            bottom: '1%',
            left: 'center',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#fff'//字体颜色
            },

          },

          color:  ["#427dfa", "#05c2f7", "#f29d65", "#db626a"],
          series: [
            {
              name: "工单状态",
              type: "pie",
              radius: "71%",
              center: ["53%", "39%"],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: "#101129",
                borderWidth: 1,
              },
              label: { 
              },
              emphasis: {
                label: {
                  show: true,
                  formatter: '{b}:{d}%',
                  fontSize: '16',

                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: 29.91, name: "待处理" },
                { value: 29.29, name: "处理中" },
                { value: 40.60, name: "已完成" },
              ],

            },
          ],
        };
        this.$refs.vchart4.setData(option, true);
      },

      //事件分布
      distribution() {
        var option = {
          tooltip: {
            trigger: "item",
            formatter: function (param) {
              return param.marker + param.name + ":" + param.value + "%";
            },
          },
          legend: {
            bottom: '1%',
            left: 'center',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            itemGap: 10, // 设置间距
            textStyle: {
              color: '#fff'//字体颜色
            },

          },

          color:  ["#427dfa", "#05c2f7", "#f29d65", "#db626a"],
          series: [
            {
              name: "事件分布",
              type: "pie",
              radius: "60%",
              center: ["50%", "38%"],

              itemStyle: {
                borderColor: "#101129",
                borderWidth: 1,
              },
              label: { 
              },

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                label: {
                  show: true,
                  formatter: '{b}:{d}%',
                  fontSize: '16',
                }
              },
              data: [
                { value: 21.68, name: "事件类型一" },
                { value: 10.62, name: "事件类型二" },
                { value: 25.33, name: "事件类型三" },
                { value: 32.28, name: "事件类型四" },
              ],

            },
          ],
        };
      this.$refs.vchart5.setData(option, true);
      },



      map() {
        echarts.registerMap('china', { "type": "FeatureCollection", "features": [{ "id": "710000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@°Ü¯Û"], ["@@ƛĴÕƊÉɼģºðʀ\\ƎsÆNŌÔĚänÜƤɊĂǀĆĴĤǊŨxĚĮǂƺòƌâÔ®ĮXŦţƸZûÐƕƑGđ¨ĭMó·ęcëƝɉlÝƯֹÅŃ^Ó·śŃǋƏďíåɛGɉ¿@ăƑ¥ĘWǬÏĶŁâ"], ["@@\\p|WoYG¿¥Ij@¢"], ["@@¡@V^RqBbAnTXeRz¤L«³I"], ["@@ÆEEkWqë @"], ["@@fced"]], "encodeOffsets": [[[122886, 24033]], [[123335, 22980]], [[122375, 24193]], [[122518, 24117]], [[124427, 22618]], [[124862, 26043]]] }, "properties": { "cp": [121.509062, 24.044332], "name": "台湾", "childNum": 6 } }, { "id": "130000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@o~Z]ªrºc_ħ²G¼s`jÎŸnüsÂłNX_M`Ç½ÓnUKĜēs¤­©yrý§uģcJe"], ["@@U`Ts¿mÂ"], ["@@oºƋÄdeVDJj£J|ÅdzÂFt~KŨ¸IÆv|¢r}èonb}`RÎÄn°ÒdÞ²^®lnÐèĄlðÓ×]ªÆ}LiĂ±Ö`^°Ç¶p®đDcŋ`ZÔ¶êqvFÆN®ĆTH®¦O¾IbÐã´BĐɢŴÆíȦpĐÞXR·nndO¤OÀĈƒ­QgµFo|gȒęSWb©osx|hYhgŃfmÖĩnºTÌSp¢dYĤ¶UĈjlǐpäìë|³kÛfw²Xjz~ÂqbTÑěŨ@|oMzv¢ZrÃVw¬ŧĖ¸f°ÐTªqs{S¯r æÝlNd®²Ğ ǆiGĘJ¼lr}~K¨ŸƐÌWöÆzR¤lêmĞLÎ@¡|q]SvKÑcwpÏÏĿćènĪWlĄkT}J¤~ÈTdpddʾĬBVtEÀ¢ôPĎƗè@~kü\\rÊĔÖæW_§¼F´©òDòjYÈrbĞāøŀG{ƀ|¦ðrb|ÀH`pʞkvGpuARhÞÆǶgĘTǼƹS£¨¡ù³ŘÍ]¿ÂyôEP xX¶¹ÜO¡gÚ¡IwÃé¦ÅBÏ|Ç°N«úmH¯âDùyŜŲIÄuĐ¨D¸dɂFOhđ©OiÃ`ww^ÌkÑH«ƇǤŗĺtFu{Z}Ö@U´ʚLg®¯Oı°Ãw ^VbÉsmAê]]w§RRl£ȭµu¯b{ÍDěïÿȧuT£ġěŗƃĝQ¨fVƋƅn­a@³@ďyÃ½IĹÊKŭfċŰóxV@tƯJ]eR¾fe|rHA|h~Ėƍl§ÏlTíb ØoÅbbx³^zÃĶ¶Sj®AyÂhðk`«PËµEFÛ¬Y¨Ļrõqi¼Wi°§Ð±´°^[À|ĠO@ÆxO\\ta\\tĕtû{ġȧXýĪÓjùÎRb^ÎfK[ÝděYfíÙTyuUSyŌŏů@Oi½éŅ­aVcř§ax¹XŻácWU£ôãºQ¨÷Ñws¥qEHÙ|šYQoŕÇyáĂ£MÃ°oťÊP¡mWO¡v{ôvîēÜISpÌhp¨ jdeŔQÖjX³àĈ[n`Yp@UcM`RKhEbpŞlNut®EtqnsÁgAiúoHqCXhfgu~ÏWP½¢G^}¯ÅīGCÑ^ãziMáļMTÃƘrMc|O_¯Ŏ´|morDkO\\mĆJfl@cĢ¬¢aĦtRıÒ¾ùƀ^juųœK­UFyƝīÛ÷ąV×qƥV¿aȉd³BqPBmaËđŻģmÅ®V¹d^KKonYg¯XhqaLdu¥Ípǅ¡KąÅkĝęěhq}HyÃ]¹ǧ£Í÷¿qáµ§g¤o^á¾ZE¤i`ĳ{nOl»WÝĔįhgF[¿¡ßkOüš_ūiǱàUtėGyl}ÓM}jpEC~¡FtoQiHkk{Ãmï"]], "encodeOffsets": [[[119712, 40641]], [[121616, 39981]], [[116462, 37237]]] }, "properties": { "cp": [114.502461, 38.045474], "name": "河北", "childNum": 3 } }, { "id": "140000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ÞĩÒSra}ÁyWix±Üe´lèßÓǏokćiµVZģ¡coTSË¹ĪmnÕńehZg{gtwªpXaĚThȑp{¶Eh®RćƑP¿£Pmc¸mQÝWďȥoÅîɡųAďä³aÏJ½¥PG­ąSM­EÅruµéYÓŌ_dĒCo­Èµ]¯_²ÕjāK~©ÅØ^ÔkïçămÏk]­±cÝ¯ÑÃmQÍ~_apm~ç¡qu{JÅŧ·Ls}EyÁÆcI{¤IiCfUcƌÃp§]ě«vD@¡SÀµMÅwuYY¡DbÑc¡h×]nkoQdaMç~eDÛtT©±@¥ù@É¡ZcW|WqOJmĩl«ħşvOÓ«IqăV¥D[mI~Ó¢cehiÍ]Ɠ~ĥqX·eƷn±}v[ěďŕ]_œ`¹§ÕōIo©b­s^}Ét±ū«³p£ÿ·Wµ|¡¥ăFÏs×¥ŅxÊdÒ{ºvĴÎêÌɊ²¶ü¨|ÞƸµȲLLúÉƎ¤ϊęĔV`_bªS^|dzY|dz¥pZbÆ£¶ÒK}tĦÔņƠPYznÍvX¶Ěn ĠÔzý¦ª÷ÑĸÙUȌ¸dòÜJð´ìúNM¬XZ´¤ŊǸ_tldI{¦ƀðĠȤ¥NehXnYGR° ƬDj¬¸|CĞKqºfƐiĺ©ª~ĆOQª ¤@ìǦɌ²æBÊTŸʂōĖĴŞȀÆÿȄlŤĒötÎ½î¼ĨXh|ªM¤Ðz"], "encodeOffsets": [[116874, 41716]] }, "properties": { "cp": [111.849248, 36.857014], "name": "山西", "childNum": 1 } }, { "id": "150000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@Č^â£ĂhĖMÈÄw\\fŦ°W ¢¾luŸDw\\̀ʉÌÛMĀ[bÓEn}¶Vcês¯PqFB|S³C|kñHdiÄ¥sŉÅPóÑÑE^ÅPpy_YtShQ·aHwsOnŉÃs©iqjUSiº]ïW«gW¡ARëśĳĘů`çõh]y»ǃǛҤxÒm~zf}pf|ÜroÈzrKÈĵSƧż؜Ġu¦ö"], ["@@sKCGS|úþXgp{ÁX¿ć{ƱȏñZáĔyoÁhA}ŅĆfdŉ_¹Y°ėǩÑ¡H¯¶oMQqð¡Ë|Ñ`ƭŁX½·óÛxğįÅcQs«tȋǅFù^it«Č¯[hAi©á¥ÇĚ×l|¹y¯YȵƓñǙµïċĻ|Düȭ¶¡oŽäÕG\\ÄT¿Òõr¯LguÏYęRƩɷŌO\\İÐ¢æ^Ŋ ĲȶȆbÜGĝ¬¿ĚVĎgª^íu½jÿĕęjık@Ľ]ėl¥ËĭûÁėéV©±ćn©­ȇÍq¯½YÃÔŉÉNÑÅÝy¹NqáʅDǡËñ­ƁYÅy̱os§ȋµʽǘǏƬɱàưN¢ƔÊuľýľώȪƺɂļxZĈ}ÌŉŪĺœĭFЛĽ̅ȣͽÒŵìƩÇϋÿȮǡŏçƑůĕ~Ç¼ȳÐUfdIxÿ\\G zâɏÙOº·pqy£@qþ@Ǟ˽IBäƣzsÂZÁàĻdñ°ŕzéØűzșCìDȐĴĺf®Àľưø@ɜÖÞKĊŇƄ§͑těï͡VAġÑÑ»d³öǍÝXĉĕÖ{þĉu¸ËʅğU̎éhɹƆ̗̮ȘǊ֥ड़ࡰţાíϲäʮW¬®ҌeרūȠkɬɻ̼ãüfƠSצɩςåȈHϚÎKǳͲOðÏȆƘ¼CϚǚ࢚˼ФÔ¤ƌĞ̪Qʤ´¼mȠJˀƲÀɠmǐnǔĎȆÞǠN~ʢĜ¶ƌĆĘźʆȬ˪ĚĒ¸ĞGȖƴƀj`ĢçĶāàŃºēĢĖćYÀŎüôQÐÂŎŞǆŞêƖoˆDĤÕºÑǘÛˤ³̀gńƘĔÀ^ªƂ`ªt¾äƚêĦĀ¼ÐĔǎ¨Ȕ»͠^ˮÊȦƤøxRrŜH¤¸ÂxDÄ|ø˂˜ƮÐ¬ɚwɲFjĔ²Äw°ǆdÀÉ_ĸdîàŎjÊêTĞªŌŜWÈ|tqĢUB~´°ÎFCU¼pĀēƄN¦¾O¶łKĊOjĚj´ĜYp{¦SĚÍ\\T×ªV÷Ší¨ÅDK°ßtŇĔK¨ǵÂcḷ̌ĚǣȄĽFlġUĵŇȣFʉɁMğįʏƶɷØŭOǽ«ƽū¹Ʊő̝Ȩ§ȞʘĖiɜɶʦ}¨֪ࠜ̀ƇǬ¹ǨE˦ĥªÔêFxúQEr´Wrh¤Ɛ \\talĈDJÜ|[Pll̚¸ƎGú´P¬W¦^¦H]prRn|or¾wLVnÇIujkmon£cX^Bh`¥V¦U¤¸}xRj[^xN[~ªxQ[`ªHÆÂExx^wN¶Ê|¨ìMrdYpoRzNyÀDs~bcfÌ`L¾n|¾T°c¨È¢ar¤`[|òDŞĔöxElÖdHÀI`Ď\\Àì~ÆR¼tf¦^¢ķ¶eÐÚMptgjɡČÅyġLûŇV®ÄÈƀĎ°P|ªVVªj¬ĚÒêp¬E|ŬÂc|ÀtƐK f{ĘFĒƌXƲąo½Ę\\¥o}Ûu£ç­kX{uĩ«āíÓUŅßŢqŤ¥lyň[oi{¦LńðFȪȖĒL¿Ìf£K£ʺoqNwğc`uetOj×°KJ±qÆġmĚŗos¬qehqsuH{¸kH¡ÊRǪÇƌbȆ¢´äÜ¢NìÉʖ¦â©Ż؛Ç@Vu»Aylßí¹ĵêÝlISò³C¹Ìâ²i¶Ìoú^H²CǜңǄ z¼g^èöŰ_Ĳĕê}gÁnUI«m]jvV¼euhwqAaW_µj»çjioQR¹ēÃßt@r³[ÛlćË^ÍÉáGOUÛOB±XkÅ¹£k|e]olkVÍ¼ÕqtaÏõjgÁ£§U^RLËnX°ÇBz^~wfvypV ¯ƫĉ˭ȫƗŷɿÿĿƑ˃ĝÿÃǃßËőó©ǐȍŒĖM×ÍEyxþp]ÉvïèvƀnÂĴÖ@V~Ĉ³MEĸÅĖtējyÄDXÄxGQuv_i¦aBçw˛wD©{tāmQ{EJ§KPśƘƿ¥@sCTÉ}ɃwƇy±gÑ}T[÷kÐç¦«SÒ¥¸ëBX½HáÅµÀğtSÝÂa[ƣ°¯¦Pï¡]£ġÒk®G²èQ°óMq}EóƐÇ\\@áügQÍu¥FTÕ¿Jû]|mvāÎYua^WoÀa·­ząÒot×¶CLƗi¯¤mƎHǊ¤îìɾŊìTdåwsRÖgĒųúÍġäÕ}Q¶¿A[¡{d×uQAMxVvMOmăl«ct[wº_ÇÊjbÂ£ĦS_éQZ_lwgOiýe`YYLq§IÁǳ£ÙË[ÕªuƏ³ÍTs·bÁĽäė[b[ŗfãcn¥îC¿÷µ[ŏÀQ­ōĉm¿Á^£mJVmL[{Ï_£F¥Ö{ŹA}×Wu©ÅaųĳƳhB{·TQqÙIķËZđ©Yc|M¡LeVUóK_QWk_ĥ¿ãZ»X\\ĴuUèlG®ěłTĠğDŃOrÍdÆÍz]±ŭ©Å]ÅÐ}UË¥©TċïxgckfWgi\\ÏĒ¥HkµEë{»ÏetcG±ahUiñiWsɁ·cCÕk]wȑ|ća}wVaĚá G°ùnM¬¯{ÈÐÆA¥ÄêJxÙ¢hP¢ÛºµwWOóFÁz^ÀŗÎú´§¢T¤ǻƺSėǵhÝÅQgvBHouʝl_o¿Ga{ïq{¥|ſĿHĂ÷aĝÇqZñiñC³ª»E`¨åXēÕqÉû[l}ç@čƘóO¿¡FUsAʽīccocÇS}£IS~ălkĩXçmĈŀÐoÐdxÒuL^T{r@¢ÍĝKén£kQyÅõËXŷƏL§~}kq»IHėǅjĝ»ÑÞoå°qTt|r©ÏS¯·eŨĕx«È[eM¿yupN~¹ÏyN£{©għWí»Í¾səšǅ_ÃĀɗ±ąĳĉʍŌŷSÉA±åǥɋ@ë£R©ąP©}ĹªƏj¹erLDĝ·{i«ƫC£µ"]], "encodeOffsets": [[[127444, 52594]], [[113793, 40312]]] }, "properties": { "cp": [111.670801, 41.818311], "name": "内蒙古", "childNum": 2 } }, { "id": "210000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@L@@sa"], ["@@MnNm"], ["@@dc"], ["@@eÀC@b"], ["@@fXwkbrÄ`qg"], ["@@^jtWQ"], ["@@~ Y]c"], ["@@G`ĔN^_¿ZÃM"], ["@@iX¶BY"], ["@@YZ"], ["@@L_{Epf"], ["@@^WqCT\\"], ["@@\\[§t|¤_"], ["@@m`n_"], ["@@Ïxǌ{q_×^Giip"], ["@@@é^BntaÊU]x ¯ÄPĲ­°hʙK³VÕ@Y~|EvĹsÇ¦­L^pÃ²ŸÒG Ël]xxÄ_fT¤Ď¤cPC¨¸TVjbgH²sdÎdHt`B²¬GJję¶[ÐhjeXdlwhðSČ¦ªVÊÏÆZÆŶ®²^ÎyÅÎcPqńĚDMħĜŁH­kçvV[ĳ¼WYÀäĦ`XlR`ôLUVfK¢{NZdĒªYĸÌÚJRr¸SA|ƴgŴĴÆbvªØX~źB|¦ÕE¤Ð`\\|KUnnI]¤ÀÂĊnŎR®Ő¿¶\\ÀøíDm¦ÎbŨabaĘ\\ľãÂ¸atÎSƐ´©v\\ÖÚÌǴ¤Â¨JKrZ_ZfjþhPkx`YRIjJcVf~sCN¤ EhæmsHy¨SðÑÌ\\\\ĐRZk°IS§fqŒßýáĞÙÉÖ[^¯ǤŲê´\\¦¬ĆPM¯£»uïpùzExanµyoluqe¦W^£ÊL}ñrkqWňûPUP¡ôJoo·U}£[·¨@XĸDXm­ÛÝºGUCÁª½{íĂ^cjk¶Ã[q¤LÉö³cux«zZf²BWÇ®Yß½ve±ÃCý£W{Ú^q^sÑ·¨ÍOt¹·C¥GDrí@wÕKţÃ«V·i}xËÍ÷i©ĝɝǡ]{c±OW³Ya±_ç©HĕoƫŇqr³Lys[ñ³¯OSďOMisZ±ÅFC¥Pq{Ã[Pg}\\¿ghćOk^ģÁFıĉĥM­oEqqZûěŉ³F¦oĵhÕP{¯~TÍlªNßYÐ{Ps{ÃVUeĎwk±ŉVÓ½ŽJãÇÇ»Jm°dhcÀffdF~ĀeĖd`sx² ®EżĀdQÂd^~ăÔH¦\\LKpĄVez¤NP ǹÓRÆąJSh­a[¦´ÂghwmBÐ¨źhI|VV|p] Â¼èNä¶ÜBÖ¼L`¼bØæKVpoúNZÞÒKxpw|ÊEMnzEQIZZNBčÚFÜçmĩWĪñtÞĵÇñZ«uD±|Əlĳ¥ãn·±PmÍada CLǑkùó¡³Ï«QaċÏOÃ¥ÕđQȥċƭy³ÃA"]], "encodeOffsets": [[[123686, 41445]], [[126019, 40435]], [[124393, 40128]], [[126117, 39963]], [[125322, 40140]], [[126686, 40700]], [[126041, 40374]], [[125584, 40168]], [[125453, 40165]], [[125362, 40214]], [[125280, 40291]], [[125774, 39997]], [[125976, 40496]], [[125822, 39993]], [[125509, 40217]], [[122731, 40949]]] }, "properties": { "cp": [123.429096, 41.796767], "name": "辽宁", "childNum": 16 } }, { "id": "220000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@pä³PClFbbÍzwBGĭZÅi»lY­ċ²SgkÇ£^Sqd¯R©é£¯S\\cZ¹iűƏCuƍÓXoR}M^o£R}oªU­FuuXHlEÅÏ©¤ÛmTþ¤D²ÄufàÀ­XXÈ±AeyYw¬dvõ´KÊ£\\rµÄlidā]|î©¾DÂVH¹Þ®ÜWnCķ W§@\\¸~¤Vp¸póIO¢VOŇürXql~òÉK]¤¥Xrfkvzpm¶bwyFoúvð¼¤ N°ąO¥«³[éǡű_°Õ\\ÚÊĝþâőàerR¨­JYlďQ[ ÏYëÐ§TGztnß¡gFkMāGÁ¤ia ÉÈ¹`\\xs¬dĆkNnuNUuP@vRY¾\\¢GªóĄ~RãÖÎĢùđŴÕhQxtcæëSɽŉíëǉ£ƍG£nj°KƘµDsØÑpyĆ¸®¿bXp]vbÍZuĂ{n^IüÀSÖ¦EvRÎûh@â[ƏÈô~FNr¯ôçR±­HÑlĢ^¤¢OðævxsŒ]ÞÁTĠs¶¿âÆGW¾ìA¦·TÑ¬è¥ÏÐJ¨¼ÒÖ¼ƦɄxÊ~StD@Ă¼Ŵ¡jlºWvÐzƦZÐ²CH AxiukdGgetqmcÛ£Ozy¥cE}|¾cZk¿uŐã[oxGikfeäT@SUwpiÚFM©£è^Ú`@v¶eňf heP¶täOlÃUgÞzŸU`l}ÔÆUvØ_Ō¬Öi^ĉi§²ÃB~¡ĈÚEgc|DC_Ȧm²rBx¼MÔ¦ŮdĨÃâYxƘDVÇĺĿg¿cwÅ\\¹¥Yĭl¤OvLjM_a W`zļMž·\\swqÝSAqŚĳ¯°kRē°wx^ĐkǂÒ\\]nrĂ}²ĊŲÒøãh·M{yMzysěnĒġV·°G³¼XÀ¤¹i´o¤ŃÈ`ÌǲÄUĞd\\iÖmÈBĤÜɲDEh LG¾ƀÄ¾{WaYÍÈĢĘÔRîĐj}ÇccjoUb½{h§Ǿ{KƖµÎ÷GĀÖŠåưÎs­lyiē«`å§H¥Ae^§GK}iã\\c]v©ģZmÃ|[M}ģTɟĵÂÂ`ÀçmFK¥ÚíÁbX³ÌQÒHof{]ept·GŋĜYünĎųVY^ydõkÅZW«WUa~U·SbwGçǑiW^qFuNĝ·EwUtW·Ýďæ©PuqEzwAVXRãQ`­©GMehccďÏd©ÑW_ÏYƅ»é\\ɹ~ǙG³mØ©BšuT§Ĥ½¢Ã_Ã½L¡ýqT^rme\\PpZZbyuybQefµ]UhĿDCmûvaÙNSkCwncćfv~YÇG"], "encodeOffsets": [[130196, 42528]] }, "properties": { "cp": [125.3245, 43.886841], "name": "吉林", "childNum": 1 } }, { "id": "230000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@ƨĶTLÇyqpÇÛqe{~oyen}s`qiXGù]Ëp½©lÉÁp]Þñ´FĂ^fäîºkàz¼BUvÈ@"], ["@@UµNÿ¥īèçHÍøƕ¶Lǽ|g¨|a¾pVidd~ÈiíďÓQġėÇZÎXb½|ſÃH½KFgɱCģÛÇAnjÕc[VĝǱÃËÇ_ £ń³pj£º¿»WH´¯U¸đĢmtĜyzzNN|g¸÷äűÑ±ĉā~mq^[ǁÑďlw]¯xQĔ¯l°řĴrBÞTxr[tŽ¸ĻN_yX`biNKuP£kZĮ¦[ºxÆÀdhĹŀUÈƗCwáZħÄŭcÓ¥»NAw±qȥnD`{ChdÙFć}¢A±Äj¨]ĊÕjŋ«×`VuÓÅ~_kŷVÝyhVkÄãPsOµfgeŇµf@u_Ù ÙcªNªÙEojVxT@ãSefjlwH\\pŏäÀvlY½d{F~¦dyz¤PÜndsrhfHcvlwjF£G±DÏƥYyÏu¹XikĿ¦ÏqƗǀOŜ¨LI|FRĂn sª|C˜zxAè¥bfudTrFWÁ¹Am|ĔĕsķÆF´N}ćUÕ@Áĳſmuçuð^ÊýowFzØÎĕNőǏȎôªÌŒǄàĀÄ˄ĞŀƒʀĀƘŸˮȬƬĊ°Uzouxe]}AyÈW¯ÌmKQ]Īºif¸ÄX|sZt|½ÚUÎ lk^p{f¤lºlÆW A²PVÜPHÊâ]ÎĈÌÜk´\\@qàsĔÄQºpRij¼èi`¶bXrBgxfv»uUi^v~J¬mVp´£´VWrnP½ì¢BX¬hðX¹^TjVriªjtŊÄmtPGx¸bgRsT`ZozÆO]ÒFôÒOÆŊvÅpcGêsx´DR{AEOr°x|íb³Wm~DVjºéNNËÜ˛ɶ­GxŷCSt}]ûōSmtuÇÃĕNāg»íT«u}ç½BĵÞʣ¥ëÊ¡MÛ³ãȅ¡ƋaǩÈÉQG¢·lG|tvgrrf«ptęŘnÅĢrI²¯LiØsPf_vĠdxM prʹL¤¤eËÀđKïÙVY§]Ióáĥ]ķK¥j|pŇ\\kzţ¦šnņäÔVĂîĪ¬|vW®l¤èØrxm¶ă~lÄƯĄ̈́öȄEÔ¤ØQĄĄ»ƢjȦOǺ¨ìSŖÆƬyQv`cwZSÌ®ü±Ǆ]ŀç¬B¬©ńzƺŷɄeeOĨSfm ĊƀP̎ēz©ĊÄÕÊmgÇsJ¥ƔŊśæÎÑqv¿íUOµªÂnĦÁ_½ä@êí£P}Ġ[@gġ}gɊ×ûÏWXá¢užƻÌsNÍ½ƎÁ§čŐAēeL³àydl¦ĘVçŁpśǆĽĺſÊQíÜçÛġÔsĕ¬Ǹ¯YßċġHµ ¡eå`ļrĉŘóƢFìĎWøxÊkƈdƬv|I|·©NqńRŀ¤éeŊŀàŀU²ŕƀBQ£Ď}L¹Îk@©ĈuǰųǨÚ§ƈnTËÇéƟÊcfčŤ^XmHĊĕË«W·ċëx³ǔķÐċJāwİ_ĸȀ^ôWr­°oú¬ĦŨK~ȰCĐ´Ƕ£fNÎèâw¢XnŮeÂÆĶ¾¾xäLĴĘlļO¤ÒĨA¢Êɚ¨®ØCÔ ŬGƠƦYĜĘÜƬDJg_ͥœ@čŅĻA¶¯@wÎqC½Ĉ»NăëKďÍQÙƫ[«ÃígßÔÇOÝáWñuZ¯ĥŕā¡ÑķJu¤E å¯°WKÉ±_d_}}vyõu¬ï¹ÓU±½@gÏ¿rÃ½DgCdµ°MFYxw¿CG£Rƛ½Õ{]L§{qqą¿BÇƻğëܭǊË|c²}Fµ}ÙRsÓpg±QNqǫŋRwŕnéÑÉK«SeYRŋ@{¤SJ}D Ûǖ֍]gr¡µŷjqWÛham³~S«Þ]"]], "encodeOffsets": [[[127123, 51780]], [[134456, 44547]]] }, "properties": { "cp": [128.642464, 46.756967], "name": "黑龙江", "childNum": 2 } }, { "id": "320000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@cþÅPi`ZRu¥É\\]~°Y`µÓ^phÁbnÀşúòaĬºTÖŒbe¦¦{¸ZâćNp©Hr|^mjhSEb\\afv`sz^lkljÄtg¤D­¾X¿À|ĐiZȀåB·î}GL¢õcßjayBFµÏC^ĭcÙt¿sğH]j{s©HM¢QnDÀ©DaÜÞ·jgàiDbPufjDk`dPOîhw¡ĥ¥GP²ĐobºrYî¶aHŢ´ ]´rılw³r_{£DB_Ûdåuk|Ũ¯F Cºyr{XFye³Þċ¿ÂkĭB¿MvÛpm`rÚã@Ę¹hågËÖƿxnlč¶Åì½Ot¾dJlVJĂǀŞqvnO^JZż·Q}êÍÅmµÒ]ƍ¦Dq}¬R^èĂ´ŀĻĊIÔtĲyQŐĠMNtR®òLhĚs©»}OÓGZz¶A\\jĨFäOĤHYJvÞHNiÜaĎÉnFQlNM¤B´ĄNöɂtpŬdfåqm¿QûùŞÚb¤uŃJŴu»¹ĄlȖħŴw̌ŵ²ǹǠ͛hĭłƕrçü±Yxcitğ®jű¢KOķCoy`å®VTa­_Ā]ŐÝɞï²ʯÊ^]afYǸÃĆēĪȣJđ͍ôƋÄÄÍīçÛɈǥ£­ÛmY`ó£Z«§°Ó³QafusNıǅ_k}¢m[ÝóDµ¡RLčiXyÅNïă¡¸iĔÏNÌŕoēdōîåŤûHcs}~Ûwbù¹£¦ÓCtOPrE^ÒogĉIµÛÅʹK¤½phMü`oæŀ"], "encodeOffsets": [[121740, 32276]] }, "properties": { "cp": [119.767413, 33.041544], "name": "江苏", "childNum": 1 } }, { "id": "330000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@E^dQ]K"], ["@@jX^j"], ["@@sfbU"], ["@@qP\\xz[ck"], ["@@R¢FX}°[s_"], ["@@Cb\\}"], ["@@e|v\\la{u"], ["@@v~u}"], ["@@QxÂF¯}"], ["@@¹nvÞs¯o"], ["@@rSkUEj"], ["@@bi­ZP"], ["@@p[}INf"], ["@@À¿"], ["@@¹dnb"], ["@@rSBnR"], ["@@g~h}"], ["@@FlEk"], ["@@OdPc"], ["@@v[u\\"], ["@@FjâL~wyoo~sµL\\"], ["@@¬e¹aN"], ["@@\\nÔ¡q]L³ë\\ÿ®QÖ"], ["@@ÊA­©[¬"], ["@@Kxv­"], ["@@@hlIk]"], ["@@pW{o||j"], ["@@Md|_mC"], ["@@¢X£ÏylD¼XtH"], ["@@hlÜ[LykAvyfw^E¤"], ["@@fp¤MusR"], ["@@®_ma~LÁ¬Z"], ["@@iMxZ"], ["@@ZcYd"], ["@@Z~dOSo|A¿qZv"], ["@@@`EN¡v"], ["@@|TY{"], ["@@@n@m"], ["@@XWkCT\\"], ["@@ºwZRkĕWO¢"], ["@@X®±GrÆª\\ÔáXq{"], ["@@ůTG°ĄLHm°UC"], ["@@¤aÜx~}dtüGæţŎíĔcŖpMËÐjē¢·ðĄÆMzjWKĎ¢Q¶À_ê_Bıi«pZgf¤Nrq]§ĂN®«H±yƳí¾×ŸīàLłčŴǝĂíÀBŖÕªÁŖHŗŉåqûõi¨hÜ·ñt»¹ýv_[«¸mYL¯QªmĉÅdMgÇjcº«ę¬­K­´B«Âącoċ\\xKd¡gěŧ«®á[~ıxu·ÅKsËÉc¢Ù\\ĭƛëbf¹­ģSĜkáƉÔ­ĈZB{aMµfzŉfåÂŧįƋǝÊĕġć£g³ne­ą»@­¦S®\\ßðChiqªĭiAuA­µ_W¥ƣO\\lċĢttC¨£t`PZäuXßBsĻyekOđġĵHuXBµ]×­­\\°®¬F¢¾pµ¼kŘó¬Wät¸|@L¨¸µrºù³Ù~§WIZW®±Ð¨ÒÉx`²pĜrOògtÁZ}þÙ]¡FKwsPlU[}¦Rvn`hq¬\\nQ´ĘRWb_ rtČFIÖkĦPJ¶ÖÀÖJĈĄTĚòC ²@PúØz©Pî¢£CÈÚĒ±hŖl¬â~nm¨f©iļ«mntuÖZÜÄjL®EÌFª²iÊxØ¨IÈhhst"], ["@@o\\VzRZ}y"], ["@@@°¡mÛGĕ¨§Ianá[ýƤjfæØLäGr"]], "encodeOffsets": [[[125592, 31553]], [[125785, 31436]], [[125729, 31431]], [[125513, 31380]], [[125223, 30438]], [[125115, 30114]], [[124815, 29155]], [[124419, 28746]], [[124095, 28635]], [[124005, 28609]], [[125000, 30713]], [[125111, 30698]], [[125078, 30682]], [[125150, 30684]], [[124014, 28103]], [[125008, 31331]], [[125411, 31468]], [[125329, 31479]], [[125626, 30916]], [[125417, 30956]], [[125254, 30976]], [[125199, 30997]], [[125095, 31058]], [[125083, 30915]], [[124885, 31015]], [[125218, 30798]], [[124867, 30838]], [[124755, 30788]], [[124802, 30809]], [[125267, 30657]], [[125218, 30578]], [[125200, 30562]], [[124968, 30474]], [[125167, 30396]], [[124955, 29879]], [[124714, 29781]], [[124762, 29462]], [[124325, 28754]], [[123990, 28459]], [[125366, 31477]], [[125115, 30363]], [[125369, 31139]], [[122495, 31878]], [[125329, 30690]], [[125192, 30787]]] }, "properties": { "cp": [120.153576, 29.287459], "name": "浙江", "childNum": 45 } }, { "id": "340000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@^iuLX^"], ["@@e©Ehl"], ["@@°ZÆëĎµmkǀwÌÕæhºgBĝâqÙĊzÖgņtÀÁĂÆáhEz|WzqD¹°Eŧl{ævÜcA`¤C`|´qxĲkq^³³GšµbíZ¹qpa±ď OH¦Ħx¢gPícOl_iCveaOjChß¸iÝbÛªCC¿mRV§¢A|t^iĠGÀtÚsd]ĮÐDE¶zAb àiödK¡~H¸íæAǿYj{ď¿À½W®£ChÃsikkly]_teu[bFaTign{]GqªoĈMYá|·¥f¥őaSÕėNµñĞ«Im_m¿Âa]uĜp Z_§{Cäg¤°r[_YjÆOdý[I[á·¥Q_nùgL¾mvˊBÜÆ¶ĊJhpc¹O]iŠ]¥ jtsggJÇ§w×jÉ©±EFË­KiÛÃÕYvsm¬njĻª§emná}k«ŕgđ²ÙDÇ¤í¡ªOy×Où±@DñSęćăÕIÕ¿IµĥOjNÕËT¡¿tNæŇàåyķrĕq§ÄĩsWÆßF¶X®¿mwRIÞfßoG³¾©uyHį{Ɓħ¯AFnuPÍÔzVdàôº^Ðæd´oG¤{S¬ćxã}ŧ×Kǥĩ«ÕOEÐ·ÖdÖsƘÑ¨[Û^Xr¢¼§xvÄÆµ`K§ tÒ´Cvlo¸fzŨð¾NY´ı~ÉĔēßúLÃÃ_ÈÏ|]ÂÏFlg`ben¾¢pUh~ƴĖ¶_r sĄ~cƈ]|r c~`¼{À{ȒiJjz`îÀT¥Û³]u}fïQl{skloNdjäËzDvčoQďHI¦rbtHĔ~BmlRV_ħTLnñH±DL¼Lªl§Ťa¸ĚlK²\\RòvDcÎJbt[¤D@®hh~kt°ǾzÖ@¾ªdbYhüóZ ň¶vHrľ\\ÊJuxAT|dmÀO[ÃÔG·ĚąĐlŪÚpSJ¨ĸLvÞcPæķŨ®mÐálwKhïgA¢ųÆ©Þ¤OÈm°K´"]], "encodeOffsets": [[[121722, 32278]], [[119475, 30423]], [[119168, 35472]]] }, "properties": { "cp": [117.283042, 31.26119], "name": "安徽", "childNum": 3 } }, { "id": "350000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@zht´]"], ["@@aj^~ĆG©O"], ["@@ed¨C}}i"], ["@@@vPGsQ"], ["@@sBzddW]Q"], ["@@S¨Q{"], ["@@NVucW"], ["@@qptBAq"], ["@@¸[mu"], ["@@Q\\pD]_"], ["@@jSwUadpF"], ["@@eXª~"], ["@@AjvFso"], ["@@fT_Çí\\v|ba¦jZÆy°"], ["@@IjJi"], ["@@wJIx«¼AoNe{M­"], ["@@K±¡ÓČäeZ"], ["@@k¡¹Eh~c®wBkUplÀ¡I~Māe£bN¨gZý¡a±Öcp©PhI¢QqÇGj|¥U g[Ky¬ŏv@OptÉEF\\@ åA¬V{XģĐBycpě¼³Ăp·¤¥ohqqÚ¡ŅLs^Ã¡§qlÀhH¨MCe»åÇGD¥zPO£čÙkJA¼ßėuĕeûÒiÁŧSW¥Qûŗ½ùěcÝ§SùĩąSWó«íęACµeRåǃRCÒÇZÍ¢ź±^dlstjD¸ZpuÔâÃH¾oLUêÃÔjjēò´ĄWƛ^Ñ¥Ħ@ÇòmOw¡õyJyD}¢ďÑÈġfZda©º²z£NjD°Ötj¶¬ZSÎ~¾c°¶ÐmxO¸¢Pl´SL|¥AȪĖMņĲg®áIJČĒü` QF¬h|ĂJ@zµ |ê³È ¸UÖŬŬÀEttĸr]ðM¤ĶĲHtÏ AĬkvsq^aÎbvdfÊòSD´Z^xPsĂrvƞŀjJd×ŘÉ ®AÎ¦ĤdxĆqAZRÀMźnĊ»İÐZ YXæJyĊ²·¶q§·K@·{sXãô«lŗ¶»o½E¡­«¢±¨Y®Ø¶^AvWĶGĒĢPlzfļtàAvWYãO_¤sD§ssČġ[kƤPX¦`¶®BBvĪjv©jx[L¥àï[F¼ÍË»ğV`«Ip}ccÅĥZEãoP´B@D¸m±z«Ƴ¿å³BRØ¶Wlâþäą`]Z£Tc ĹGµ¶Hm@_©k¾xĨôȉðX«½đCIbćqK³ÁÄš¬OAwã»aLŉËĥW[ÂGIÂNxĳ¤D¢îĎÎB§°_JGs¥E@¤ućPåcuMuw¢BI¿]zG¹guĮck\\_"]], "encodeOffsets": [[[123250, 27563]], [[122541, 27268]], [[123020, 27189]], [[122916, 27125]], [[122887, 26845]], [[122808, 26762]], [[122568, 25912]], [[122778, 26197]], [[122515, 26757]], [[122816, 26587]], [[123388, 27005]], [[122450, 26243]], [[122578, 25962]], [[121255, 25103]], [[120987, 24903]], [[122339, 25802]], [[121042, 25093]], [[122439, 26024]]] }, "properties": { "cp": [118.306239, 26.075302], "name": "福建", "childNum": 18 } }, { "id": "360000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ĢĨƐgļ¼ÂMD~ņªe^\\^§ý©j×cZØ¨zdÒa¶lÒJìõ`oz÷@¤uŞ¸´ôęöY¼HČƶajlÞƩ¥éZ[|h}^U  ¥pĄžƦO lt¸Æ Q\\aÆ|CnÂOjt­ĚĤdÈF`¶@Ðë ¦ōÒ¨SêvHĢûXD®QgÄWiØPÞìºr¤ǆNĠ¢lĄtZoCƞÔºCxrpĠV®Ê{f_Y`_eq®Aot`@oDXfkp¨|s¬\\DÄSfè©Hn¬^DhÆyøJhØxĢĀLÊƠPżċĄwȠĚ¦G®ǒĤäTŠÆ~Ħw«|TF¡nc³Ïå¹]ĉđxe{ÎÓvOEm°BƂĨİ|Gvz½ª´HàpeJÝQxnÀW­EµàXÅĪt¨ÃĖrÄwÀFÎ|ňÓMå¼ibµ¯»åDT±m[r«_gmQu~¥V\\OkxtL E¢Ú^~ýêPóqoě±_Êw§ÑªåƗā¼mĉŹ¿NQYBąrwģcÍ¥B­ŗÊcØiIƝĿuqtāwO]³YCñTeÉcaubÍ]trluīBÐGsĵıN£ï^ķqss¿FūūVÕ·´Ç{éĈýÿOER_đûIċâJh­ŅıNȩĕB¦K{Tk³¡OP·wnµÏd¯}½TÍ«YiµÕsC¯iM¤­¦¯P|ÿUHvhe¥oFTuõ\\OSsMòđƇiaºćXĊĵà·çhƃ÷Ç{ígu^đgm[×zkKN¶Õ»lčÓ{XSÆv©_ÈëJbVkĔVÀ¤P¾ºÈMÖxlò~ªÚàGĂ¢B±ÌKyáV¼Ã~­`gsÙfIƋlę¹e|~udjuTlXµf`¿Jd[\\L²"], "encodeOffsets": [[116689, 26234]] }, "properties": { "cp": [115.592151, 27.676493], "name": "江西", "childNum": 1 } }, { "id": "370000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@Xjd]{K"], ["@@itbFHy"], ["@@HlGk"], ["@@TGy"], ["@@K¬U"], ["@@WdXc"], ["@@PtOs"], ["@@LnXhc"], ["@@ppVu]Or"], ["@@cdzAUa"], ["@@udRhnCI"], ["@@oIpR"], ["@@Ľč{fzƤîKÎMĮ]ZF½Y]â£ph¶¨râøÀÎǨ¤^ºÄGz~grĚĜlĞÆLĆǆ¢Îo¦cvKbgr°WhmZp L]LºcUÆ­nżĤÌĒbAnrOA´ȊcÀbƦUØrĆUÜøĬƞEzVL®öØBkŖÝĐĖ¹ŧ̄±ÀbÎÉnb²ĦhņBĖįĦåXćì@L¯´ywƕCéÃµė ƿ¸lµ¾Z|ZWyFY¨Mf~C¿`à_RÇzwƌfQnny´INoƬèôº|sTJULîVjǎ¾ĒØDz²XPn±ŴPè¸ŔLƔÜƺ_TüÃĤBBċÈöA´faM¨{«M`¶d¡ôÖ°mȰBÔjj´PM|c^d¤u¤Û´ä«ƢfPk¶Môl]Lb}su^ke{lCMrDÇ­]NÑFsmoõľHyGă{{çrnÓEƕZGª¹Fj¢ïWuøCǷë¡ąuhÛ¡^KxC`C\\bÅxì²ĝÝ¿_NīCȽĿåB¥¢·IŖÕy\\¹kxÃ£Č×GDyÃ¤ÁçFQ¡KtŵƋ]CgÏAùSedcÚźuYfyMmhUWpSyGwMPqŀÁ¼zK¶G­Y§Ë@´śÇµƕBm@IogZ¯uTMx}CVKï{éƵP_K«pÛÙqċtkkù]gTğwoɁsMõ³ăAN£MRkmEÊčÛbMjÝGuIZGPģãħE[iµBEuDPÔ~ª¼ęt]ûG§¡QMsğNPŏįzs£Ug{đJĿļā³]ç«Qr~¥CƎÑ^n¶ÆéÎR~Ż¸YI] PumŝrƿIā[xeÇ³L¯v¯s¬ÁY~}ťuŁgƋpÝĄ_ņī¶ÏSR´ÁP~¿Cyċßdwk´SsX|t`Ä ÈðAªìÎT°¦Dda^lĎDĶÚY°`ĪŴǒàŠv\\ebZHŖR¬ŢƱùęOÑM­³FÛWp["]], "encodeOffsets": [[[123806, 39303]], [[123821, 39266]], [[123742, 39256]], [[123702, 39203]], [[123649, 39066]], [[123847, 38933]], [[123580, 38839]], [[123894, 37288]], [[123043, 36624]], [[123344, 38676]], [[123522, 38857]], [[123628, 38858]], [[118260, 36742]]] }, "properties": { "cp": [118.000923, 36.275807], "name": "山东", "childNum": 13 } }, { "id": "410000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ýLùµP³swIÓxcŢĞð´E®ÚPtĴXØxÂ¶@«ŕŕQGYfa[şußǩđš_X³ĳÕčC]kbc¥CS¯ëÍB©÷³­Si_}mYTt³xlàcČzÀD}ÂOQ³ÐTĨ¯ƗòËŖ[hłŦv~}ÂZ«¤lPÇ£ªÝŴÅR§ØnhctâknÏ­ľŹUÓÝdKuķI§oTũÙďkęĆH¸Ó\\Ä¿PcnS{wBIvÉĽ[GqµuŇôYgûZca©@½Õǽys¯}lgg@­C\\£asIdÍuCQñ[L±ęk·ţb¨©kK»KC²òGKmĨS`UQnk}AGēsqaJ¥ĐGRĎpCuÌy ã iMcplk|tRkðev~^´¦ÜSí¿_iyjI|ȑ|¿_»d}q^{Ƈdă}tqµ`Ƴĕg}V¡om½faÇo³TTj¥tĠRyK{ùÓjuµ{t}uËRivGçJFjµÍyqÎàQÂFewixGw½Yŷpµú³XU½ġyłåkÚwZX·l¢Á¢KzOÎÎjc¼htoDHr|­J½}JZ_¯iPq{tę½ĕ¦Zpĵø«kQĹ¤]MÛfaQpě±ǽ¾]u­Fu÷nčÄ¯ADp}AjmcEÇaª³o³ÆÍSƇĈÙDIzËčľ^KLiÞñ[aA²zzÌ÷D|[íÄ³gfÕÞd®|`Ć~oĠƑô³ŊD×°¯CsøÀ«ìUMhTº¨¸ǡîSÔDruÂÇZÖEvPZW~ØÐtĄE¢¦Ðy¸bô´oŬ¬²Ês~]®tªapŎJ¨Öº_Ŕ`Ŗ^Đ\\Ĝu~m²Ƹ¸fWĦrƔ}Î^gjdfÔ¡J}\\n C¦þWxªJRÔŠu¬ĨĨmFdM{\\d\\YÊ¢ú@@¦ª²SÜsC}fNècbpRmlØ^gd¢aÒ¢CZZxvÆ¶N¿¢T@uC¬^ĊðÄn|lGlRjsp¢ED}Fio~ÔN~zkĘHVsǲßjŬŢ`Pûàl¢\\ÀEhİgÞē X¼Pk|m"], "encodeOffsets": [[118256, 37017]] }, "properties": { "cp": [113.665412, 33.757975], "name": "河南", "childNum": 1 } }, { "id": "420000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@AB"], ["@@lskt"], ["@@¾«}{ra®pîÃ\\{øCËyyB±b\\òÝjKL ]ĎĽÌJyÚCƈćÎT´Å´pb©ÈdFin~BCo°BĎÃømv®E^vǾ½Ĝ²RobÜeN^ĺ£R¬lĶ÷YoĖ¥Ě¾|sOr°jY`~I¾®I{GqpCgyl{£ÍÍyPLÂ¡¡¸kWxYlÙæŁĢz¾V´W¶ùŸo¾ZHxjwfxGNÁ³Xéæl¶EièIH ujÌQ~v|sv¶Ôi|ú¢FhQsğ¦SiŠBgÐE^ÁÐ{čnOÂÈUÎóĔÊēĲ}Z³½Mŧïeyp·uk³DsÑ¨L¶_ÅuÃ¨w»¡WqÜ]\\Ò§tƗcÕ¸ÕFÏǝĉăxŻČƟOKÉġÿ×wg÷IÅzCg]m«ªGeçÃTC«[t§{loWeC@ps_Bp­rf_``Z|ei¡oċMqow¹DƝÓDYpûsYkıǃ}s¥ç³[§cY§HK«Qy]¢wwö¸ïx¼ņ¾Xv®ÇÀµRĠÐHM±cÏdƒǍũȅȷ±DSyúĝ£ŤĀàtÖÿï[îb\\}pĭÉI±Ñy¿³x¯No|¹HÏÛmjúË~TuęjCöAwě¬Rđl¯ Ñb­ŇTĿ_[IčĄʿnM¦ğ\\É[T·k¹©oĕ@A¾wya¥Y\\¥Âaz¯ãÁ¡k¥ne£ÛwE©Êō¶˓uoj_U¡cF¹­[WvP©whuÕyBF`RqJUw\\i¡{jEPïÿ½fćQÑÀQ{°fLÔ~wXgītêÝ¾ĺHd³fJd]HJ²EoU¥HhwQsƐ»Xmg±çve]DmÍPoCc¾_hhøYrŊU¶eD°Č_N~øĹĚ·`z]Äþp¼äÌQv\\rCé¾TnkžŐÚÜa¼ÝƆĢ¶ÛodĔňÐ¢JqPb ¾|J¾fXƐîĨ_Z¯À}úƲN_ĒÄ^ĈaŐyp»CÇÄKñL³ġM²wrIÒŭxjb[n«øæà ^²­h¯ÚŐªÞ¸Y²ĒVø}Ā^İ´LÚm¥ÀJÞ{JVųÞŃx×sxxƈē ģMřÚðòIfĊŒ\\Ʈ±ŒdÊ§ĘDvČ_Àæ~Dċ´A®µ¨ØLV¦êHÒ¤"]], "encodeOffsets": [[[113712, 34000]], [[115612, 30507]], [[113649, 34054]]] }, "properties": { "cp": [113.298572, 30.684355], "name": "湖北", "childNum": 3 } }, { "id": "430000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@nFTs"], ["@@ßÅÆá½ÔXrCOËRïÿĩ­TooQyÓ[ŅBE¬ÎÓXaį§Ã¸G °ITxpúxÚĳ¥ÏĢ¾edÄ©ĸGàGhM¤Â_U}Ċ}¢pczfþg¤ÇòAVM"], ["@@©KA·³CQ±Á«³BUƑ¹AtćOwD]JiØSm¯b£ylXHËÑ±H«C^õľAÅ§¤É¥ïyuǙuA¢^{ÌC´­¦ŷJ£^[ª¿ĕ~ƇN skóā¹¿ï]ă~÷O§­@Vm¡Qđ¦¢Ĥ{ºjÔª¥nf´~Õo×ÛąMąıuZmZcÒ ĲĪ²SÊǄŶ¨ƚCÖŎªQØ¼rŭ­«}NÏürÊ¬mjr@ĘrTW ­SsdHzƓ^ÇÂyUi¯DÅYlŹu{hT}mĉ¹¥ěDÿë©ıÓ[Oº£¥ótł¹MÕƪ`PDiÛU¾ÅâìUñBÈ£ýhedy¡oċ`pfmjP~kZaZsÐd°wj§@Ĵ®w~^kÀÅKvNmX\\¨aŃqvíó¿F¤¡@ũÑVw}S@j}¾«pĂrªg àÀ²NJ¶¶DôK|^ª°LX¾ŴäPĪ±£EXd^¶ĲÞÜ~u¸ǔMRhsRe`ÄofIÔ\\Ø  ićymnú¨cj ¢»GČìƊÿÐ¨XeĈĀ¾Oð Fi ¢|[jVxrIQ_EzAN¦zLU`cªxOTu RLÄ¢dVi`p˔vŎµªÉF~Ød¢ºgİàw¸Áb[¦Zb¦z½xBĖ@ªpºlS¸Ö\\Ĕ[N¥ˀmĎăJ\\ŀ`ňSÚĖÁĐiOĜ«BxDõĚivSÌ}iùÜnÐºG{p°M´wÀÒzJ²ò¨ oTçüöoÛÿñőĞ¤ùTz²CȆȸǎŪƑÐc°dPÎğË¶[È½u¯½WM¡­ÉB·rínZÒ `¨GA¾\\pēXhÃRC­üWGġuTé§ŎÑ©ò³I±³}_EÃħg®ęisÁPDmÅ{b[RÅs·kPŽƥóRoOV~]{g\\êYƪ¦kÝbiċƵGZ»Ěõó·³vŝ£ø@pyö_ëIkÑµbcÑ§y×dYØªiþ¨[]f]Ņ©C}ÁN»hĻħƏĩ"]], "encodeOffsets": [[[115640, 30489]], [[112543, 27312]], [[116690, 26230]]] }, "properties": { "cp": [111.782279, 28.09409], "name": "湖南", "childNum": 3 } }, { "id": "440000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@QdAua"], ["@@lxDLo"], ["@@sbhNLo"], ["@@Ă ā"], ["@@WltO[["], ["@@Kr]S"], ["@@eI]y"], ["@@I|Mym"], ["@@Û³LS¼Y"], ["@@nvºBëui©`¾"], ["@@zdÛJw®"], ["@@°¯"], ["@@a yAª¸ËJIxØ@ĀHAmÃV¡ofuo"], ["@@sŗÃÔėAƁZÄ ~°ČPäh"], ["@@¶ÝÌvmĞh­ıQ"], ["@@HdSjĒ¢D}waru«ZqadYM"], ["@@el\\LqqU"], ["@@~rMo\\"], ["@@f^C"], ["@@øPªoj÷ÍÝħXČx°Q¨ıXNv"], ["@@gÇƳo[~tly"], ["@@EÆC¿"], ["@@OP"], ["@@wđógĝ[³¡VÙæÅöMÌ³¹pÁaËýý©D©ÜJŹƕģGą¤{ÙūÇO²«BƱéAÒĥ¡«BhlmtÃPµyU¯ucd·w_bŝcīímGO|KPȏŹãŝIŕŭŕ@Óoo¿ē±ß}ŭĲWÈCőâUâǙIğŉ©IĳE×Á³AówXJþ±ÌÜÓĨ£L]ĈÙƺZǾĆĖMĸĤfÎĵlŨnÈĐtFFĤêk¶^k°f¶g}®Faf`vXŲxl¦ÔÁ²¬Ð¦pqÊÌ²iXØRDÎ}Ä@ZĠsx®AR~®ETtĄZƈfŠŠHâÒÐAµ\\S¸^wĖkRzalŜ|E¨ÈNĀňZTpBh£\\ĎƀuXĖtKL¶G|»ĺEļĞ~ÜĢÛĊrOÙîvd]n¬VÊĜ°RÖpMƂªFbwEÀ©\\¤]ŸI®¥D³|Ë]CöAŤ¦æ´¥¸Lv¼¢ĽBaôF~®²GÌÒEYzk¤°ahlVÕI^CxĈPsBƒºV¸@¾ªR²ĨN]´_eavSivc}p}Đ¼ƌkJÚe th_¸ ºx±ò_xNË²@ă¡ßH©Ùñ}wkNÕ¹ÇO½¿£ĕ]ly_WìIÇª`uTÅxYĒÖ¼kÖµMjJÚwn\\hĒv]îh|ÈƄøèg¸Ķß ĉĈWb¹ƀdéĘNTtP[öSvrCZaGubo´ŖÒÇĐ~¡zCIözx¢PnÈñ @ĥÒ¦]ƞV}³ăĔñiiÄÓVépKG½ÄÓávYoC·sitiaÀyŧÎ¡ÈYDÑům}ý|m[węõĉZÅxUO}÷N¹³ĉo_qtăqwµŁYÙǝŕ¹tïÛUÃ¯mRCºĭ|µÕÊK½Rē ó]GªęAx»HO£|ām¡diď×YïYWªŉOeÚtĐ«zđ¹TāúEá²\\ķÍ}jYàÙÆſ¿Çdğ·ùTßÇţʄ¡XgWÀǇğ·¿ÃOj YÇ÷Qěi"]], "encodeOffsets": [[[117381, 22988]], [[116552, 22934]], [[116790, 22617]], [[116973, 22545]], [[116444, 22536]], [[116931, 22515]], [[116496, 22490]], [[116453, 22449]], [[113301, 21439]], [[118726, 21604]], [[118709, 21486]], [[113210, 20816]], [[115482, 22082]], [[113171, 21585]], [[113199, 21590]], [[115232, 22102]], [[115739, 22373]], [[115134, 22184]], [[113056, 21175]], [[119573, 21271]], [[119957, 24020]], [[115859, 22356]], [[116561, 22649]], [[116285, 22746]]] }, "properties": { "cp": [113.280637, 23.125178], "name": "广东", "childNum": 24 } }, { "id": "450000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@H TQ§A"], ["@@ĨÊªLƊDÎĹĐCǦė¸zÚGn£¾rªŀÜt¬@ÖÚSx~øOŒŶÐÂæȠ\\ÈÜObĖw^oÞLf¬°bI lTØBÌF£Ć¹gñĤaYt¿¤VSñK¸¤nM¼JE±½¸ñoÜCƆæĪ^ĚQÖ¦^f´QüÜÊz¯lzUĺš@ìp¶n]sxtx¶@~ÒĂJb©gk{°~c°`Ô¬rV\\la¼¤ôá`¯¹LCÆbxEræOv[H­[~|aB£ÖsºdAĐzNÂðsÞÆĤªbab`ho¡³F«èVlo¤ÔRzpp®SĪº¨ÖºNĳd`a¦¤F³ºDÎńĀìCĜº¦Ċ~nS|gźvZkCÆj°zVÈÁƔ]LÊFZgčP­kini«qÇczÍY®¬Ů»qR×ō©DÕ§ƙǃŵTÉĩ±ıdÑnYYĲvNĆĆØÜ Öp}e³¦m©iÓ|¹ħņ|ª¦QF¢Â¬ʖovg¿em^ucà÷gÕuíÙćĝ}FĻ¼Ĺ{µHKsLSđƃrč¤[AgoSŇYMÿ§Ç{FśbkylQxĕ]T·¶[BÑÏGáşşƇeăYSs­FQ}­BwtYğÃ@~CÍQ ×WjË±rÉ¥oÏ ±«ÓÂ¥kwWűmcih³K~µh¯e]lµélEģEďsmÇŧē`ãògK_ÛsUʝćğ¶höO¤Ǜn³c`¡y¦CezYwa[ďĵűMę§]XÎ_íÛ]éÛUćİÕBƣ±dy¹T^dûÅÑŦ·PĻþÙ`K¦¢ÍeĥR¿³£[~äu¼dltW¸oRM¢ď\\z}Æzdvň{ÎXF¶°Â_ÒÂÏL©ÖTmu¼ãlīkiqéfA·Êµ\\őDc¥ÝFyÔćcűH_hLÜêĺĐ¨c}rn`½Ì@¸¶ªVLhŒ\\Ţĺk~Ġið°|gtTĭĸ^xvKVGréAébUuMJVÃO¡qĂXËSģãlýà_juYÛÒBG^éÖ¶§EGÅzěƯ¤EkN[kdåucé¬dnYpAyČ{`]þ¯TbÜÈk¡ĠvàhÂƄ¢Jî¶²"]], "encodeOffsets": [[[111707, 21520]], [[107619, 25527]]] }, "properties": { "cp": [108.320004, 22.82402], "name": "广西", "childNum": 2 } }, { "id": "460000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@¦Ŝil¢XƦƞòïè§ŞCêɕrŧůÇąĻõ·ĉ³œ̅kÇm@ċȧŧĥĽʉ­ƅſȓÒË¦ŝE}ºƑ[ÍĜȋ gÎfǐÏĤ¨êƺ\\Ɔ¸ĠĎvʄȀÐ¾jNðĀÒRZǆzÐŘÎ°H¨Ƣb²_Ġ "], "encodeOffsets": [[112750, 20508]] }, "properties": { "cp": [109.83119, 19.031971], "name": "海南", "childNum": 1 } }, { "id": "510000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@LqKr"], ["@@[ĻéV£_ţġñpG réÏ·~ąSfy×Í·ºſƽiÍıƣıĻmHH}siaX@iÇ°ÁÃ×t«­T¤JJJyJÈ`Ohß¦¡uËhIyCjmÿwZGTiSsOB²fNmsPa{M{õE^Hj}gYpaeu¯oáwHjÁ½M¡pMuåmni{fk\\oÎqCwEZ¼KĝAy{m÷LwO×SimRI¯rKõBS«sFe]fµ¢óY_ÆPRcue°Cbo×bd£ŌIHgtrnyPt¦foaXďxlBowz_{ÊéWiêEGhÜ¸ºuFĈIxf®Y½ĀǙ]¤EyF²ċw¸¿@g¢§RGv»áW`ÃĵJwi]t¥wO­½a[×]`Ãi­üL¦LabbTÀåc}ÍhÆh®BHî|îºÉk­¤Sy£ia©taį·Ɖ`ō¥UhOĝLk}©Fos´JmµlŁuønÑJWÎªYÀïAetTŅÓGË«bo{ıwodƟ½OġÜÂµxàNÖ¾P²§HKv¾]|BÆåoZ`¡Ø`ÀmºĠ~ÌÐ§nÇ¿¤]wğ@srğu~Io[é±¹ ¿ſđÓ@qg¹zƱřaí°KtÇ¤V»Ã[ĩǭƑ^ÇÓ@áťsZÏÅĭƋěpwDóÖáŻneQËq·GCœýS]x·ýq³OÕ¶Qzßti{řáÍÇWŝŭñzÇWpç¿JXĩè½cFÂLiVjx}\\NŇĖ¥GeJA¼ÄHfÈu~¸Æ«dE³ÉMA|bÒćhG¬CMõƤąAvüVéŀ_VÌ³ĐwQj´·ZeÈÁ¨X´Æ¡Qu·»ÕZ³ġqDoy`L¬gdp°şp¦ėìÅĮZ°Iähzĵf²å ĚÑKpIN|Ñz]ń·FU×é»R³MÉ»GM«kiér}Ã`¹ăÞmÈnÁîRǀ³ĜoİzŔwǶVÚ£À]ɜ»ĆlƂ²ĠþTº·àUȞÏʦ¶I«dĽĢdĬ¿»Ĕ×h\\c¬ä²GêëĤł¥ÀǿżÃÆMº}BÕĢyFVvwxBèĻĒ©ĈtCĢɽŠȣ¦āæ·HĽîôNÔ~^¤Ɗu^s¼{TA¼ø°¢İªDè¾Ň¶ÝJ®Z´ğ~Sn|ªWÚ©òzPOȸbð¢|øĞŒQìÛÐ@ĞǎRS¤Á§di´ezÝúØã]HqkIþËQÇ¦ÃsÇ¤[E¬ÉŪÍxXƒ·ÖƁİlƞ¹ª¹|XÊwnÆƄmÀêErĒtD®ċæcQE®³^ĭ¥©l}äQtoŖÜqÆkµªÔĻĴ¡@Ċ°B²Èw^^RsºTĀ£ŚæQPJvÄz^Đ¹Æ¯fLà´GC²dt­ĀRt¼¤ĦOðğfÔðDŨŁĞƘïPÈ®âbMüÀXZ ¸£@Å»»QÉ­]dsÖ×_Í_ÌêŮPrĔĐÕGĂeZÜîĘqBhtO ¤tE[h|YÔZśÎs´xº±Uñt|OĩĠºNbgþJy^dÂY Į]Řz¦gC³R`Āz¢Aj¸CL¤RÆ»@­Ŏk\\Ç´£YW}z@Z}Ã¶oû¶]´^NÒ}èNªPÍy¹`S°´ATeVamdUĐwʄvĮÕ\\uÆŗ¨Yp¹àZÂmWh{á}WØǍÉüwga§áCNęÎ[ĀÕĪgÖÉªXøx¬½Ů¦¦[NÎLÜUÖ´òrÙŠxR^JkĳnDX{U~ET{ļº¦PZcjF²Ė@pg¨B{u¨ŦyhoÚD®¯¢ WòàFÎ¤¨GDäz¦kŮPġqË¥À]eâÚ´ªKxīPÖ|æ[xÃ¤JÞĥsNÖ½I¬nĨY´®ÐƐmDŝuäđđEbee_v¡}ìęǊē}qÉåT¯µRs¡M@}ůaa­¯wvƉåZw\\Z{åû^"]], "encodeOffsets": [[[108815, 30935]], [[110617, 31811]]] }, "properties": { "cp": [104.065735, 30.659462], "name": "四川", "childNum": 2 } }, { "id": "520000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@G\\lY£in"], ["@@q|mc¯tÏVSÎ"], ["@@hÑ£IsNgßHHªķÃh_¹¡ĝÄ§ń¦uÙùgS¯JH|sÝÅtÁïyMDč»eÕtA¤{b\\}G®u\\åPFqwÅaDK°ºâ_£ùbµmÁÛĹM[q|hlaªāI}Ñµ@swtwm^oµDéĽŠyVky°ÉûÛR³e¥]RÕěħ[ƅåÛDpJiVÂF²I»mN·£LbÒYbWsÀbpkiTZĄă¶Hq`ĥ_J¯ae«KpÝx]aĕÛPÇȟ[ÁåŵÏő÷Pw}TÙ@Õs«ĿÛq©½m¤ÙH·yǥĘĉBµĨÕnđ]K©œáGçş§ÕßgǗĦTèƤƺ{¶ÉHÎd¾ŚÊ·OÐjXWrãLyzÉAL¾ę¢bĶėy_qMĔąro¼hĊw¶øV¤w²Ĉ]ÊKx|`ź¦ÂÈdrcÈbe¸`I¼čTF´¼Óýȃr¹ÍJ©k_șl³´_pĐ`oÒh¶pa^ÓĔ}D»^Xy`d[KvJPhèhCrĂĚÂ^Êƌ wZL­Ġ£ÁbrzOIlMMĪŐžËr×ÎeŦtw|¢mKjSǘňĂStÎŦEtqFT¾Eì¬¬ôxÌO¢ K³ŀºäYPVgŎ¦ŊmŞ¼VZwVlz¤£Tl®ctĽÚó{G­AÇge~Îd¿æaSba¥KKûj®_Ä^\\Ø¾bP®¦x^sxjĶI_Ä Xâ¼Hu¨Qh¡À@Ëô}±GNìĎlT¸`V~R°tbÕĊ`¸úÛtÏFDu[MfqGH·¥yAztMFe|R_GkChZeÚ°tov`xbDnÐ{E}ZèxNEÞREn[Pv@{~rĆAB§EO¿|UZ~ìUf¨J²ĂÝÆsªB`s¶fvö¦Õ~dÔq¨¸º»uù[[§´sb¤¢zþF¢ÆÀhÂW\\ıËIÝo±ĭŠ£þÊs}¡R]ěDg´VG¢j±®èºÃmpU[Áëº°rÜbNu¸}º¼`niºÔXĄ¤¼ÔdaµÁ_ÃftQQgR·Ǔv}Ý×ĵ]µWc¤F²OĩųãW½¯K©]{LóµCIµ±Mß¿h©āq¬o½~@i~TUxŪÒ¢@£ÀEîôruńb[§nWuMÆLl¿]x}ĳ­½"]], "encodeOffsets": [[[112158, 27383]], [[112105, 27474]], [[112095, 27476]]] }, "properties": { "cp": [106.713478, 26.578343], "name": "贵州", "childNum": 3 } }, { "id": "530000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@[ùx½}ÑRHYīĺûsÍniEoã½Ya²ė{c¬ĝgĂsAØÅwďõzFjw}«Dx¿}Uũlê@HÅ­F¨ÇoJ´Ónũuą¡Ã¢pÒÅØ TF²xa²ËXcÊlHîAßËŁkŻƑŷÉ©hW­æßUËs¡¦}teèÆ¶StÇÇ}Fd£jĈZĆÆ¤Tč\\D}O÷£U§~ŃGåŃDĝ¸Tsd¶¶Bª¤u¢ŌĎo~t¾ÍŶÒtD¦ÚiôözØX²ghįh½Û±¯ÿm·zR¦Ɵ`ªŊÃh¢rOÔ´£Ym¼èêf¯ŪĽncÚbw\\zlvWªâ ¦gmĿBĹ£¢ƹřbĥkǫßeeZkÙIKueT»sVesbaĕ  ¶®dNĄÄpªy¼³BE®lGŭCǶwêżĔÂepÍÀQƞpC¼ŲÈ­AÎô¶RäQ^Øu¬°_Èôc´¹ò¨PÎ¢hlĎ¦´ĦÆ´sâÇŲPnÊD^¯°Upv}®BPÌªjǬxSöwlfòªvqĸ|`H­viļndĜ­Ćhňem·FyÞqóSį¯³X_ĞçêtryvL¤§z¦c¦¥jnŞklD¤øz½ĜàĂŧMÅ|áƆàÊcðÂFÜáŢ¥\\\\ºİøÒÐJĴîD¦zK²ǏÎEh~CD­hMn^ÌöÄ©ČZÀaüfɭyœpį´ěFűk]Ôě¢qlÅĆÙa¶~ÄqêljN¬¼HÊNQ´ê¼VØ¸E^ŃÒyM{JLoÒęæe±Ķygã¯JYÆĭĘëo¥Šo¯hcK«z_prC´ĢÖY¼ v¸¢RÅW³Â§fÇ¸Yi³xR´ďUË`êĿUûuĆBƣöNDH«ĈgÑaB{ÊNF´¬c·Åv}eÇÃGB»If¦HňĕM~[iwjUÁKE¾dĪçWIèÀoÈXòyŞŮÈXâÎŚj|àsRyµÖPr´þ ¸^wþTDŔHr¸RÌmfżÕâCôoxĜƌÆĮÐYtâŦÔ@]ÈǮƒ\\Ī¼Ä£UsÈ¯LbîƲŚºyhr@ĒÔƀÀ²º\\êpJ}ĠvqtĠ@^xÀ£È¨mËÏğ}n¹_¿¢×Y_æpÅA^{½Lu¨GO±Õ½ßM¶wÁĢÛPƢ¼pcĲx|apÌ¬HÐŊSfsðBZ¿©XÏÒKk÷Eû¿SrEFsÕūkóVǥŉiTL¡n{uxţÏhôŝ¬ğōNNJkyPaqÂğ¤K®YxÉƋÁ]āęDqçgOgILu\\_gz]W¼~CÔē]bµogpÑ_oď`´³Țkl`IªºÎȄqÔþ»E³ĎSJ»_f·adÇqÇc¥Á_Źw{L^É±ćxU£µ÷xgĉp»ĆqNē`rĘzaĵĚ¡K½ÊBzyäKXqiWPÏÉ¸½řÍcÊG|µƕƣGË÷k°_^ý|_zċBZocmø¯hhcæ\\lMFlư£ĜÆyHF¨µêÕ]HAàÓ^it `þßäkĤÎT~Wlÿ¨ÔPzUCNVv [jâôDôď[}z¿msSh¯{jïğl}šĹ[őgK©U·µË@¾m_~q¡f¹ÅË^»f³ø}Q¡ÖË³gÍ±^Ç\\ëÃA_¿bWÏ[¶ƛé£F{īZgm@|kHǭƁć¦UĔť×ë}ǝeďºȡȘÏíBÉ£āĘPªĳ¶ŉÿy©nď£G¹¡I±LÉĺÑdĉÜW¥}gÁ{aqÃ¥aıęÏZï`"], "encodeOffsets": [[104636, 22969]] }, "properties": { "cp": [101.512251, 24.740609], "name": "云南", "childNum": 1 } }, { "id": "540000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ÂhľxŖxÒVºÅâAĪÝȆµę¯Ňa±r_w~uSÕňqOj]ɄQ£ZUDûoY»©M[L¼qãË{VÍçWVi]ë©Ä÷àyƛhÚU°adcQ~Mx¥cc¡ÙaSyFÖk­uRýq¿ÔµQĽ³aG{¿FµëªéĜÿª@¬·K·àariĕĀ«V»ŶĴūgèLǴŇƶaftèBŚ£^âǐÝ®M¦ÁǞÿ¬LhJ¾óƾÆºcxwf]Y´¦|QLn°adĊ\\¨oǀÍŎ´ĩĀd`tÊQŞŕ|¨C^©Ĉ¦¦ÎJĊ{ëĎjª²rÐl`¼Ą[t|¦Stè¾PÜK¸dƄı]s¤î_v¹ÎVòŦj£Əsc¬_Ğ´|Ł¦Av¦w`ăaÝaa­¢e¤ı²©ªSªÈMĄwÉØŔì@T¤Ę\\õª@þo´­xA sÂtŎKzó´ÇĊµ¢r^nĊ­Æ¬×üG¢³ {âĊ]G~bÀgVjzlhǶfOfdªB]pjTOtĊn¤}®¦Č¥d¢¼»ddY¼t¢eȤJ¤}Ǿ¡°§¤AÐlc@ĝsªćļđAçwxUuzEÖġ~AN¹ÄÅȀŻ¦¿ģŁéì±Hãd«g[Ø¼ēÀcīľġ¬cJµÐʥVȝ¸ßS¹ý±ğkƁ¼ą^ɛ¤Ûÿb[}¬ōõÃ]ËNm®g@Bg}ÍF±ǐyL¥íCIĳÏ÷Ñį[¹¦[âšEÛïÁÉdƅß{âNÆāŨß¾ě÷yC£k­´ÓH@Â¹TZ¥¢į·ÌAÐ§®Zcv½Z­¹|ÅWZqgW|ieZÅYVÓqdqbc²R@c¥Rã»GeeƃīQ}J[ÒK¬Ə|oėjġĠÑN¡ð¯EBčnwôɍėª²CλŹġǝʅįĭạ̃ūȹ]ΓͧgšsgȽóϧµǛęgſ¶ҍć`ĘąŌJÞä¤rÅň¥ÖÁUětęuůÞiĊÄÀ\\Æs¦ÓRb|Â^řÌkÄŷ¶½÷f±iMÝ@ĥ°G¬ÃM¥n£Øąğ¯ß§aëbéüÑOčk£{\\eµª×MÉfm«Ƒ{Å×Gŏǩãy³©WÑăû··Qòı}¯ãIéÕÂZ¨īès¶ZÈsæĔTŘvgÌsN@îá¾ó@ÙwU±ÉTå»£TđWxq¹Zobs[×¯cĩvėŧ³BM|¹kªħ¥TzNYnÝßpęrñĠĉRS~½ěVVµõ«M££µBĉ¥áºae~³AuĐh`Ü³ç@BÛïĿa©|z²Ý¼D£àč²ŸIûI āóK¥}rÝ_Á´éMaň¨~ªSĈ½½KÙóĿeƃÆB·¬ën×W|Uº}LJrƳlŒµ`bÔ`QÐÓ@s¬ñIÍ@ûws¡åQÑßÁ`ŋĴ{ĪTÚÅTSÄ³Yo|Ç[Ç¾µMW¢ĭiÕØ¿@MhpÕ]jéò¿OƇĆƇpêĉâlØwěsǩĵ¸cbU¹ř¨WavquSMzeo_^gsÏ·¥Ó@~¯¿RiīB\\qTGªÇĜçPoÿfñòą¦óQīÈáPābß{ZŗĸIæÅhnszÁCËìñÏ·ąĚÝUm®ó­L·ăUÈíoù´Êj°ŁŤ_uµ^°ìÇ@tĶĒ¡ÆM³Ģ«İĨÅ®ğRāðggheÆ¢zÊ©Ô\\°ÝĎz~ź¤PnMĪÖB£kné§żćĆKĒ°¼L¶èâz¨u¦¥LDĘz¬ýÎmĘd¾ßFzhg²Fy¦ĝ¤ċņbÎ@yĄæm°NĮZRÖíJ²öLĸÒ¨Y®ƌÐVàtt_ÚÂyĠz]ŢhzĎ{ÂĢXc|ÐqfO¢¤ögÌHNPKŖUú´xx[xvĐCûĀìÖT¬¸^}Ìsòd´_KgžLĴÀBon|H@Êx¦BpŰŌ¿fµƌA¾zǈRx¶FkĄźRzŀ~¶[´HnªVƞuĒ­È¨ƎcƽÌm¸ÁÈM¦x͊ëÀxǆBú^´W£dkɾĬpw˂ØɦļĬIŚÊnŔa¸~J°îlɌxĤÊÈðhÌ®gT´øàCÀ^ªerrƘd¢İP|Ė ŸWªĦ^¶´ÂLaT±üWƜǀRÂŶUńĖ[QhlLüAÜ\\qRĄ©"], "encodeOffsets": [[90849, 37210]] }, "properties": { "cp": [89.132212, 30.860361], "name": "西藏", "childNum": 1 } }, { "id": "610000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@p¢ȮµûGĦ}Ħðǚ¶òƄjɂz°{ºØkÈęâ¦jªBg\\ċ°s¬]jú EȌǆ¬stRÆdĠİwÜ¸ôW¾ƮłÒ_{Ìû¼jº¹¢GǪÒ¯ĘZ`ºŊecņą~BÂgzpâēòYǠȰÌTÎ¨ÂW|fcă§uF@N¢XLRMº[ğȣſï|¥Jkc`sŉǷY¹W@µ÷Kãï³ÛIcñ·VȋÚÒķø©þ¥yÓğęmWµÎumZyOŅƟĥÓ~sÑL¤µaÅY¦ocyZ{y c]{Ta©`U_Ěē£ωÊƍKùK¶ȱÝƷ§{û»ÅÁȹÍéuĳ|¹cÑdìUYOuFÕÈYvÁCqÓTǢí§·S¹NgV¬ë÷Át°DØ¯C´ŉƒópģ}ċcEËFéGU¥×K§­¶³BČ}C¿åċ`wġB·¤őcƭ²ő[Å^axwQOÿEËßŚĤNĔwƇÄńwĪ­o[_KÓª³ÙnKÇěÿ]ďă_d©·©Ýŏ°Ù®g]±ßå¬÷m\\iaǑkěX{¢|ZKlçhLtŇîŵœè[É@ƉĄEtƇÏ³­ħZ«mJ×¾MtÝĦ£IwÄå\\Õ{OwĬ©LÙ³ÙgBƕŀrÌĢŭO¥lãyC§HÍ£ßEñX¡­°ÙCgpťzb`wIvA|§hoĕ@E±iYd¥OĻ¹S|}F@¾oAO²{tfÜ¢FǂÒW²°BĤh^Wx{@¬­F¸¡ķn£P|ªĴ@^ĠĈæbÔc¶lYi^MicĎ°Â[ävï¶gv@ÀĬ·lJ¸sn|¼u~a]ÆÈtŌºJpþ£KKf~¦UbyäIĺãnÔ¿^­ŵMThĠÜ¤ko¼Ŏìąǜh`[tRd²Ĳ_XPrɲlXiL§à¹H°Ȧqº®QCbAŌJ¸ĕÚ³ĺ§ `d¨YjiZvRĺ±öVKkjGȊÄePĞZmļKÀ[`ösìhïÎoĬdtKÞ{¬èÒÒBÔpĲÇĬJŊ¦±J«Y§@·pHµàåVKepWftsAÅqC·¬ko«pHÆuK@oHĆÛķhxenS³àǍrqƶRbzy¸ËÐl¼EºpĤ¼x¼½~Ğà@ÚüdK^mÌSj"], "encodeOffsets": [[110234, 38774]] }, "properties": { "cp": [108.948024, 34.263161], "name": "陕西", "childNum": 1 } }, { "id": "620000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@VuUv"], ["@@ũEĠtt~nkh`Q¦ÅÄÜdwAb×ĠąJ¤DüègĺqBqj°lI¡ĨÒ¤úSHbjÎB°aZ¢KJO[|A£Dx}NĂ¬HUnrk kp¼Y kMJn[aGáÚÏ[½rc}aQxOgsPMnUsncZsKúvAtÞġ£®ĀYKdnFw¢JE°Latf`¼h¬we|Æbj}GA·~W`¢MC¤tL©Ĳ°qdfObÞĬ¹ttu`^ZúE`[@Æsîz®¡CƳƜG²R¢RmfwĸgÜą G@pzJM½mhVy¸uÈÔO±¨{LfæU¶ßGĂq\\ª¬²I¥IŉÈīoıÓÑAçÑ|«LÝcspīðÍgtë_õ\\ĉñLYnĝgRǡÁiHLlõUĹ²uQjYi§Z_c¨´ĹĖÙ·ŋIaBD­R¹ȥr¯GºßK¨jWkɱOqWĳ\\a­Q\\sg_ĆǛōëp»£lğÛgSŶN®À]ÓämĹãJaz¥V}Le¤Lýo¹IsŋÅÇ^bz³tmEÁ´a¹cčecÇNĊãÁ\\č¯dNj]jZµkÓdaćå]ğĳ@ ©O{¤ĸm¢E·®«|@Xwg]Aģ±¯XǁÑǳªcwQÚŝñsÕ³ÛV_ý¥\\ů¥©¾÷w©WÕÊĩhÿÖÁRo¸V¬âDb¨hûxÊ×ǌ~Zâg|XÁnßYoº§ZÅŘv[ĭÖʃuďxcVbnUSfB¯³_TzºÎO©çMÑ~M³]µ^püµÄY~y@X~¤Z³[Èōl@®Å¼£QK·Di¡ByÿQ_´D¥hŗy^ĭÁZ]cIzýah¹MĪğPs{ò²Vw¹t³ŜË[Ñ}X\\gsF£sPAgěp×ëfYHāďÖqēŭOÏëdLü\\it^c®RÊº¶¢H°mrY£B¹čIoľu¶uI]vģSQ{UŻÅ}QÂ|Ì°ƅ¤ĩŪU ęĄÌZÒ\\v²PĔ»ƢNHĂyAmƂwVm`]ÈbH`Ì¢²ILvĜH®¤Dlt_¢JJÄämèÔDëþgºƫaʎÌrêYi~ Îİ¤NpÀA¾Ĕ¼bð÷®üszMzÖĖQdȨýv§Tè|ªHÃ¾a¸|Ð ƒwKĢx¦ivr^ÿ ¸l öæfƟĴ·PJv}n\\h¹¶v·À|\\ƁĚN´ĜçèÁz]ġ¤²¨QÒŨTIlªťØ}¼˗ƦvÄùØEÂ«FïËIqōTvāÜŏíÛßÛVj³âwGăÂíNOPìyV³ŉĖýZso§HÑiYw[ß\\X¦¥c]ÔƩÜ·«jÐqvÁ¦m^ċ±R¦΋ƈťĚgÀ»IïĨʗƮ°ƝĻþÍAƉſ±tÍEÕÞāNUÍ¡\\ſčåÒʻĘm ƭÌŹöʥëQ¤µ­ÇcƕªoIýIÉ_mkl³ăƓ¦j¡YzŇi}Msßõīʋ }ÁVm_[n}eı­Uĥ¼ªI{Î§DÓƻėojqYhĹT©oūĶ£]ďxĩǑMĝq`B´ƃ˺Чç~²ņj@¥@đ´ί}ĥtPńÇ¾V¬ufÓÉCtÓ̻¹£G³]ƖƾŎĪŪĘ̖¨ʈĢƂlɘ۪üºňUðǜȢƢż̌ȦǼĤŊɲĖÂ­Kq´ï¦ºĒǲņɾªǀÞĈĂD½ĄĎÌŗĞrôñnN¼â¾ʄľԆ|Ǆ֦ज़ȗǉ̘̭ɺƅêgV̍ʆĠ·ÌĊv|ýĖÕWĊǎÞ´õ¼cÒÒBĢ͢UĜð͒s¨ňƃLĉÕÝ@ɛƯ÷¿Ľ­ĹeȏĳëCȚDŲyê×Ŗyò¯ļcÂßYtÁƤyAã˾J@ǝrý@¤rz¸oP¹ɐÚyáHĀ[JwcVeȴÏ»ÈĖ}ƒŰŐèȭǢόĀƪÈŶë;Ñ̆ȤМľĮEŔĹŊũ~ËUă{ĻƹɁύȩþĽvĽƓÉ@ēĽɲßǐƫʾǗĒpäWÐxnsÀ^ƆwW©¦cÅ¡Ji§vúF¶¨c~c¼īeXǚ\\đ¾JwÀďksãAfÕ¦L}waoZD½Ml«]eÒÅaÉ²áo½FõÛ]ĻÒ¡wYR£¢rvÓ®y®LFLzĈôe]gx}|KK}xklL]c¦£fRtív¦PĤoH{tK"]], "encodeOffsets": [[[108619, 36299]], [[108589, 36341]]] }, "properties": { "cp": [103.823557, 36.058039], "name": "甘肃", "childNum": 2 } }, { "id": "630000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@InJm"], ["@@CÆ½OŃĦsΰ~Ē³¦@@Ņi±è}ШƄ˹A³r_ĞǒNĪĐw¤^ŬĵªpĺSZgrpiƼĘÔ¨C|ÍJ©Ħ»®VĲ~f\\m `UnÂ~ʌĬàöNt~ňjy¢ZiƔ¥Ąk´nl`JÊJþ©pdƖ®È£¶ìRʦźõƮËnʼėæÑƀĎ[¢VÎĂMÖÝÎF²sƊƀÎBļýƞ¯ʘƭðħ¼Jh¿ŦęΌƇ¥²Q]Č¥nuÂÏri¸¬ƪÛ^Ó¦d¥[Wàx\\ZjÒ¨GtpþYŊĕ´zUOëPîMĄÁxH´áiÜUàîÜŐĂÛSuŎrJðÌ¬EFÁú×uÃÎkrĒ{V}İ«O_ÌËĬ©ÓŧSRÑ±§Ģ£^ÂyèçěM³Ƃę{[¸¿uºµ[gt£¸OƤĿéYõ·kĀq]juw¥DĩƍõÇPéÄ½G©ã¤GuȧþRcÕĕNyyût­øï»a½ē¿BMoį£Íj}éZËqbʍƬh¹ìÿÓAçãnIÃ¡I`ks£CG­ěUy×Cy@¶ʡÊBnāzGơMē¼±O÷õJËĚăVĪũƆ£¯{ËL½ÌzżVR|ĠTbuvJvµhĻĖHAëáa­OÇðñęNwœľ·LmI±íĠĩPÉ×®ÿscB³±JKßĊ«`ađ»·QAmOVţéÿ¤¹SQt]]Çx±¯A@ĉĳ¢Óļ©l¶ÅÛrŕspãRk~¦ª]Į­´FRåd­ČsCqđéFn¿ÅƃmÉx{W©ºƝºįkÕƂƑ¸wWūÐ©ÈF£\\tÈ¥ÄRÈýÌJ lGr^×äùyÞ³fjc¨£ÂZ|ǓMĝÏ@ëÜőRĝ÷¡{aïȷPu°ËXÙ{©TmĠ}Y³­ÞIňµç½©C¡į÷¯B»|St»]vųs»}MÓ ÿʪƟǭA¡fs»PY¼c¡»¦cċ­¥£~msĉPSi^o©AecPeǵkgyUi¿h}aHĉ^|á´¡HØûÅ«ĉ®]m¡qĉ¶³ÈyôōLÁstB®wn±ă¥HSòė£Së@×œÊăxÇN©©T±ª£Ĳ¡fb®Þbb_Ą¥xu¥B{łĝ³«`dƐt¤ťiñÍUuºí`£^tƃĲc·ÛLO½sç¥Ts{ă\\_»kÏ±q©čiìĉ|ÍI¥ć¥]ª§D{ŝŖÉR_sÿc³ĪōƿÎ§p[ĉc¯bKmR¥{³Ze^wx¹dƽÅ½ôIg §Mĕ ƹĴ¿ǣÜÍ]Ý]snåA{eƭ`ǻŊĿ\\ĳŬűYÂÿ¬jĖqßb¸L«¸©@ěĀ©ê¶ìÀEH|´bRľÓ¶rÀQþvl®ÕETzÜdb hw¤{LRdcb¯ÙVgƜßzÃôì®^jUèXÎ|UäÌ»rK\\ªN¼pZCüVY¤ɃRi^rPŇTÖ}|br°qňbĚ°ªiƶGQ¾²x¦PmlŜ[Ĥ¡ΞsĦÔÏâ\\ªÚŒU\\f¢N²§x|¤§xĔsZPòʛ²SÐqF`ªVÞŜĶƨVZÌL`¢dŐIqr\\oäõFÎ·¤»Ŷ×h¹]ClÙ\\¦ďÌį¬řtTӺƙgQÇÓHţĒ´ÃbEÄlbʔC|CŮkƮ[ʼ¬ň´KŮÈΰÌĪ¶ƶlðļATUvdTGº̼ÔsÊDÔveOg"]], "encodeOffsets": [[[105308, 37219]], [[95370, 40081]]] }, "properties": { "cp": [96.778916, 35.623178], "name": "青海", "childNum": 2 } }, { "id": "640000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@KëÀęĞ«Oęȿȕı]ŉ¡åįÕÔ«ǴõƪĚQÐZhv K°öqÀÑS[ÃÖHƖčËnL]ûcÙß@ĝ¾}w»»oģF¹»kÌÏ·{zP§B­¢íyÅt@@á]Yv_ssģ¼ißĻL¾ġsKD£¡N_X¸}B~HaiÅf{«x»ge_bsKF¯¡IxmELcÿZ¤­ĢÝsuBLùtYdmVtNmtOPhRw~bd¾qÐ\\âÙH\\bImlNZ»loqlVmGā§~QCw¤{A\\PKNY¯bFkC¥sks_Ã\\ă«¢ħkJi¯rrAhĹûç£CUĕĊ_ÔBixÅÙĄnªÑaM~ħpOu¥sîeQ¥¤^dkKwlL~{L~hw^ófćKyE­K­zuÔ¡qQ¤xZÑ¢^ļöÜ¾Ep±âbÊÑÆ^fk¬NC¾YpxbK~¥eÖäBlt¿Đx½I[ĒǙWf»Ĭ}d§dµùEuj¨IÆ¢¥dXªƅx¿]mtÏwßRĶX¢͎vÆzƂZò®ǢÌʆCrâºMÞzÆMÒÊÓŊZÄ¾r°Î®Ȉmª²ĈUªĚîøºĮ¦ÌĘk^FłĬhĚiĀĖ¾iİbjÕ"], ["@@mfwěwMrŢªv@G"]], "encodeOffsets": [[[109366, 40242]], [[108600, 36303]]] }, "properties": { "cp": [106.278179, 37.26637], "name": "宁夏", "childNum": 2 } }, { "id": "650000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@QØĔ²X¨~ǘBºjʐßØvKƔX¨vĊOÃ·¢i@~cĝe_«E}QxgɪëÏÃ@sÅyXoŖ{ô«ŸuXêÎf`C¹ÂÿÐGĮÕĞXŪōŸMźÈƺQèĽôe|¿ƸJR¤ĘEjcUóº¯Ĩ_ŘÁMª÷Ð¥OéÈ¿ÖğǤǷÂFÒzÉx[]­Ĥĝœ¦EP}ûƥé¿İƷTėƫœŕƅƱB»Đ±ēO¦E}`cȺrĦáŖuÒª«ĲπdƺÏØZƴwʄ¤ĖGĐǂZĶèH¶}ÚZצʥĪï|ÇĦMŔ»İĝǈì¥Βba­¯¥ǕǚkĆŵĦɑĺƯxūД̵nơʃĽá½M»òmqóŘĝčË¾ăCćāƿÝɽ©ǱŅ¹đ¥³ðLrÁ®ɱĕģŉǻ̋ȥơŻǛȡVï¹Ň۩ûkɗġƁ§ʇė̕ĩũƽō^ƕUv£ƁQïƵkŏ½ΉÃŭÇ³LŇʻ«ƭ\\lŭD{ʓDkaFÃÄa³ŤđÔGRÈƚhSӹŚsİ«ĐË[¥ÚDkº^Øg¼ŵ¸£EÍöůŉT¡c_ËKYƧUśĵÝU_©rETÏʜ±OñtYwē¨{£¨uM³x½şL©Ùá[ÓÐĥ Νtģ¢\\śnkOw¥±T»ƷFɯàĩÞáB¹ÆÑUwŕĽw[mG½Èå~Æ÷QyěCFmĭZīŵVÁƿQƛûXS²b½KÏ½ĉS©ŷXĕ{ĕK·¥Ɨcqq©f¿]ßDõU³h­gËÇïģÉɋwk¯í}I·œbmÉřīJɥĻˁ×xoɹīlc¤³Xù]ǅA¿w͉ì¥wÇN·ÂËnƾƍdÇ§đ®ƝvUm©³G\\}µĿQyŹlăµEwǇQ½yƋBe¶ŋÀůo¥AÉw@{Gpm¿AĳŽKLh³`ñcËtW±»ÕSëüÿďDu\\wwwù³VLŕOMËGh£õP¡erÏd{ġWÁč|yšg^ğyÁzÙs`s|ÉåªÇ}m¢Ń¨`x¥ù^}Ì¥H«YªƅAÐ¹n~ź¯f¤áÀzgÇDIÔ´AňĀÒ¶ûEYospõD[{ù°]uJqU|Soċxţ[õÔĥkŋÞŭZËºóYËüċrw ÞkrťË¿XGÉbřaDü·Ē÷AÃª[ÄäIÂ®BÕĐÞ_¢āĠpÛÄȉĖġDKwbmÄNôfƫVÉviǳHQµâFù­Âœ³¦{YGd¢ĚÜO {Ö¦ÞÍÀP^bƾl[vt×ĈÍEË¨¡Đ~´î¸ùÎhuè`¸HÕŔVºwĠââWò@{ÙNÝ´ə²ȕn{¿¥{l÷eé^eďXj©î\\ªÑòÜìc\\üqÕ[Č¡xoÂċªbØ­ø|¶ȴZdÆÂońéG\\¼C°ÌÆn´nxÊOĨŪƴĸ¢¸òTxÊǪMīĞÖŲÃɎOvʦƢ~FRěò¿ġ~åŊúN¸qĘ[Ĕ¶ÂćnÒPĒÜvúĀÊbÖ{Äî¸~Ŕünp¤ÂH¾ĄYÒ©ÊfºmÔĘcDoĬMŬS¤s²ʘÚžȂVŦ èW°ªB|ĲXŔþÈJĦÆæFĚêYĂªĂ]øªŖNÞüAfɨJ¯ÎrDDĤ`mz\\§~D¬{vJÂ«lµĂb¤pŌŰNĄ¨ĊXW|ų ¿¾ɄĦƐMTòP÷fØĶK¢ȝ˔Sô¹òEð­`Ɩ½ǒÂň×äı§ĤƝ§C~¡hlåǺŦŞkâ~}FøàĲaĞfƠ¥Ŕd®U¸źXv¢aƆúŪtŠųƠjdƺƺÅìnrh\\ĺ¯äɝĦ]èpĄ¦´LƞĬ´ƤǬ˼Ēɸ¤rºǼ²¨zÌPðŀbþ¹ļD¢¹\\ĜÑŚ¶ZƄ³àjĨoâȴLÊȮĐ­ĚăÀêZǚŐ¤qȂ\\L¢ŌİfÆs|zºeªÙæ§΢{Ā´ƐÚ¬¨Ĵà²łhʺKÞºÖTiƢ¾ªì°`öøu®Ê¾ãØ"], "encodeOffsets": [[88824, 50096]] }, "properties": { "cp": [85.617733, 40.792818], "name": "新疆", "childNum": 1 } }, { "id": "110000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ĽOÁûtŷmiÍt_H»Ĩ±d`¹­{bwYr³S]§§o¹qGtm_SŧoaFLgQN_dV@Zom_ć\\ßcÂ±x¯oœRcfe£o§ËgToÛJíĔóu|wP¤XnO¢ÉŦ¯rNÄā¤zâŖÈRpŢZÚ{GrFt¦Òx§ø¹RóäV¤XdżâºWbwŚ¨Ud®bêņ¾jnŎGŃŶnzÚSeîĜZczî¾i]ÍQaúÍÔiþĩȨWĢü|Ėu[qb[swP@ÅğP¿{\\¥A¨ÏÑ¨j¯X\\¯MKpA³[Hīu}}"], "encodeOffsets": [[120023, 41045]] }, "properties": { "cp": [116.405285, 39.904989], "name": "北京", "childNum": 1 } }, { "id": "120000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@ŬgX§Ü«E¶FÌ¬O_ïlÁgz±AXeµÄĵ{¶]gitgIj·¥îakS¨ÐƎk}ĕ{gBqGf{¿aU^fIư³õ{YıëNĿk©ïËZŏR§òoY×Ógcĥs¡bġ«@dekąI[nlPqCnp{ō³°`{PNdƗqSÄĻNNâyj]äÒD ĬH°Æ]~¡HO¾X}ÐxgpgWrDGpù^LrzWxZ^¨´T\\|~@IzbĤjeĊªz£®ĔvěLmV¾Ô_ÈNW~zbĬvG²ZmDM~~"], "encodeOffsets": [[120237, 41215]] }, "properties": { "cp": [117.190182, 39.125596], "name": "天津", "childNum": 1 } }, { "id": "310000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@ɧư¬EpƸÁxc"], ["@@©ª"], ["@@MA"], ["@@QpİE§ÉC¾"], ["@@bŝÕÕEȣÚƥêImɇǦèÜĠÚÃƌÃ͎ó"], ["@@ǜûȬɋŭ×^sYɍDŋŽąñCG²«ªč@h_p¯A{oloY¬j@Ĳ`gQÚhr|ǀ^MĲvtbe´R¯Ô¬¨Yô¤r]ìƬį"]], "encodeOffsets": [[[124702, 32062]], [[124547, 32200]], [[124808, 31991]], [[124726, 32110]], [[124903, 32376]], [[124438, 32149]]] }, "properties": { "cp": [121.472644, 31.231706], "name": "上海", "childNum": 6 } }, { "id": "500000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@vjG~nGŘŬĶȂƀƾ¹¸ØÎezĆT¸}êÐqHðqĖä¥^CÆIj²p\\_ æüY|[YxƊæu°xb®Űb@~¢NQt°¶Sæ Ê~rǉĔëĚ¢~uf`faĔJåĊnÖ]jƎćÊ@£¾a®£Ű{ŶĕFègLk{Y|¡ĜWƔtƬJÑxq±ĢN´òKLÈÃ¼D|s`ŋć]Ã`đMûƱ½~Y°ħ`ƏíW½eI½{aOIrÏ¡ĕŇapµÜƅġ^ÖÛbÙŽŏml½SêqDu[RãË»ÿw`»y¸_ĺę}÷`M¯ċfCVµqŉ÷Zgg`d½pDOÎCn^uf²ènh¼WtƏxRGg¦pVFI±G^Ic´ecGĹÞ½sëĬhxW}KÓe­XsbkF¦LØgTkïƵNï¶}Gyw\\oñ¡nmĈzj@Óc£»Wă¹Ój_m»¹·~MvÛaq»­ê\\ÂoVnÓØÍ²«bq¿efE Ĝ^Q~ Évýş¤²ĮpEİ}zcĺL½¿gÅ¡ýE¡ya£³t\\¨\\vú»¼§·Ñr_oÒý¥u_n»_At©ÞÅ±ā§IVeëY}{VPÀFA¨ąB}q@|Ou\\FmQFÝMwå}]|FmÏCawu_p¯sfÙgYDHl`{QEfNysB¦zG¸rHeN\\CvEsÐùÜ_·ÖĉsaQ¯}_UxÃđqNH¬Äd^ÝŰR¬ã°wećJE·vÝ·HgéFXjÉê`|ypxkAwWĐpb¥eOsmzwqChóUQl¥F^lafanòsrEvfQdÁUVfÎvÜ^eftET¬ôA\\¢sJnQTjPØxøK|nBzĞ»LYFDxÓvr[ehľvN¢o¾NiÂxGpâ¬zbfZo~hGi]öF||NbtOMn eA±tPTLjpYQ|SHYĀxinzDJÌg¢và¥Pg_ÇzIIII£®S¬ØsÎ¼£N"], ["@@ifjN@s"]], "encodeOffsets": [[[109628, 30765]], [[111725, 31320]]] }, "properties": { "cp": [107.304962, 29.533155], "name": "重庆", "childNum": 2 } }, { "id": "810000", "type": "Feature", "geometry": { "type": "MultiPolygon", "coordinates": [["@@AlBk"], ["@@mn"], ["@@EpFo"], ["@@ea¢pl¸Eõ¹hj[]ÔCÎ@lj¡uBX´AI¹[yDU]W`çwZkmcMpÅv}IoJlcafŃK°ä¬XJmÐ đhI®æÔtSHnEÒrÈc"], ["@@rMUwAS®e"]], "encodeOffsets": [[[117111, 23002]], [[117072, 22876]], [[117045, 22887]], [[116975, 23082]], [[116882, 22747]]] }, "properties": { "cp": [114.173355, 22.320048], "name": "香港", "childNum": 5 } }, { "id": "820000", "type": "Feature", "geometry": { "type": "Polygon", "coordinates": ["@@kÊd°å§s"], "encodeOffsets": [[116279, 22639]] }, "properties": { "cp": [113.54909, 22.198951], "name": "澳门", "childNum": 1 } }], "UTF8Encoding": true });

        var geoCoordMap = {
          '新疆玛纳斯基地': [86.22, 44.30],
          '九江': [116.00, 29.70],
          '新乡': [116.402217, 35.311657],
          ' ': [79.92, 37.12],
          '  ': [86.85, 47.70],
          '若羌县': [88.17, 39.02],
          '上海': [121.4648, 31.2891],
          '东莞': [113.8953, 22.901],
          '东营': [118.7073, 37.5513],
          '中山': [113.4229, 22.478],
          '临汾': [111.4783, 36.1615],
          '临沂': [118.3118, 35.2936],
          '丹东': [124.541, 40.4242],
          '丽水': [119.5642, 28.1854],
          '乌鲁木齐': [87.9236, 43.5883],
          '佛山': [112.8955, 23.1097],
          '保定': [115.0488, 39.0948],
          '兰州': [103.5901, 36.3043],
          '包头': [110.3467, 41.4899],
          '北京': [116.4551, 40.2539],
          '北海': [109.314, 21.6211],
          '南京': [118.8062, 31.9208],
          '南宁': [108.479, 23.1152],
          '南昌': [116.0046, 28.6633],
          '南通': [121.1023, 32.1625],
          '厦门': [118.1689, 24.6478],
          '台州': [121.1353, 28.6688],
          '合肥': [117.29, 32.0581],
          '呼和浩特': [111.4124, 40.4901],
          '咸阳': [108.4131, 34.8706],
          '哈尔滨': [127.9688, 45.368],
          '唐山': [118.4766, 39.6826],
          '嘉兴': [120.9155, 30.6354],
          '大同': [113.7854, 39.8035],
          '大连': [122.2229, 39.4409],
          '天津': [117.4219, 39.4189],
          '太原': [112.3352, 37.9413],
          '威海': [121.9482, 37.1393],
          '宁波': [121.5967, 29.6466],
          '宝鸡': [107.1826, 34.3433],
          '宿迁': [118.5535, 33.7775],
          '常州': [119.4543, 31.5582],
          '广州': [113.5107, 23.2196],
          '廊坊': [116.521, 39.0509],
          '延安': [109.1052, 36.4252],
          '张家口': [115.1477, 40.8527],
          '徐州': [117.5208, 34.3268],
          '德州': [116.6858, 37.2107],
          '惠州': [114.6204, 23.1647],
          '成都': [103.9526, 30.7617],
          '扬州': [119.4653, 32.8162],
          '承德': [117.5757, 41.4075],
          '拉萨': [91.1865, 30.1465],
          '无锡': [120.3442, 31.5527],
          '日照': [119.2786, 35.5023],
          '昆明': [102.9199, 25.4663],
          '杭州': [119.5313, 29.8773],
          '枣庄': [117.323, 34.8926],
          '柳州': [109.3799, 24.9774],
          '株洲': [113.5327, 27.0319],
          '武汉': [114.3896, 30.6628],
          '汕头': [117.1692, 23.3405],
          '江门': [112.6318, 22.1484],
          '沈阳': [123.1238, 42.1216],
          '沧州': [116.8286, 38.2104],
          '河源': [114.917, 23.9722],
          '泉州': [118.3228, 25.1147],
          '泰安': [117.0264, 36.0516],
          '泰州': [120.0586, 32.5525],
          '济南': [117.1582, 36.8701],
          '济宁': [116.8286, 35.3375],
          '海口': [110.3893, 19.8516],
          '淄博': [118.0371, 36.6064],
          '淮安': [118.927, 33.4039],
          '深圳': [114.5435, 22.5439],
          '清远': [112.9175, 24.3292],
          '温州': [120.498, 27.8119],
          '渭南': [109.7864, 35.0299],
          '湖州': [119.8608, 30.7782],
          '湘潭': [112.5439, 27.7075],
          '滨州': [117.8174, 37.4963],
          '潍坊': [119.0918, 36.524],
          '烟台': [120.7397, 37.5128],
          '玉溪': [101.9312, 23.8898],
          '珠海': [113.7305, 22.1155],
          '盐城': [120.2234, 33.5577],
          '盘锦': [121.9482, 41.0449],
          '石家庄': [114.4995, 38.1006],
          '福州': [119.4543, 25.9222],
          '秦皇岛': [119.2126, 40.0232],
          '绍兴': [120.564, 29.7565],
          '聊城': [115.9167, 36.4032],
          '肇庆': [112.1265, 23.5822],
          '舟山': [122.2559, 30.2234],
          '苏州': [120.6519, 31.3989],
          '莱芜': [117.6526, 36.2714],
          '菏泽': [115.6201, 35.2057],
          '营口': [122.4316, 40.4297],
          '葫芦岛': [120.1575, 40.578],
          '衡水': [115.8838, 37.7161],
          '衢州': [118.6853, 28.8666],
          '西宁': [101.4038, 36.8207],
          '西安': [109.1162, 34.2004],
          '贵阳': [106.6992, 26.7682],
          '连云港': [119.1248, 34.552],
          '邢台': [114.8071, 37.2821],
          '邯郸': [114.4775, 36.535],
          '郑州': [113.4668, 34.6234],
          '鄂尔多斯': [108.9734, 39.2487],
          '重庆': [107.7539, 30.1904],
          '金华': [120.0037, 29.1028],
          '铜川': [109.0393, 35.1947],
          '银川': [106.3586, 38.1775],
          '镇江': [119.4763, 31.9702],
          '长春': [125.8154, 44.2584],
          '长沙': [113.0823, 28.2568],
          '长治': [112.8625, 36.4746],
          '阳泉': [113.4778, 38.0951],
          '青岛': [120.4651, 36.3373],
          '韶关': [113.7964, 24.7028]
        };

        var BJData = [
          [{
            name: '新乡'
          }, {
            name: '新乡',
            value: 200
          }],
          [{
            name: '新乡'
          }, {
            name: '呼和浩特',
            value: 90
          }],
          [{
            name: '新乡'
          }, {
            name: '哈尔滨',
            value: 90
          }],
          [{
            name: '新乡'
          }, {
            name: '石家庄',
            value: 90
          }],
          [{
            name: '新乡'
          }, {
            name: '昆明',
            value: 30
          }],
          [{
            name: '新乡'
          }, {
            name: '北京',
            value: 100
          }],
          [{
            name: '新乡'
          }, {
            name: '长春',
            value: 40
          }],
          [{
            name: '新乡'
          }, {
            name: '重庆',
            value: 40
          }],
          [{
            name: '新乡'
          }, {
            name: '贵阳',
            value: 50
          }],
          [{
            name: '新乡'
          }, {
            name: '南宁',
            value: 30
          }],
          [{
            name: '新乡'
          }, {
            name: '济南',
            value: 10
          }],
          [{
            name: '新乡'
          }, {
            name: '太原',
            value: 40
          }],
          [{
            name: '新乡'
          }, {
            name: '西安',
            value: 60
          }],
          [{
            name: '新乡'
          }, {
            name: '武汉',
            value: 50
          }],
          [{
            name: '新乡'
          }, {
            name: '合肥',
            value: 40
          }],
          [{
            name: '新乡'
          }, {
            name: '南京',
            value: 30
          }],
          [{
            name: '新乡'
          }, {
            name: '沈阳',
            value: 20
          }],
          [{
            name: '新乡'
          }, {
            name: '成都',
            value: 10
          }]
        ];

        var SHData = [
          [{
            name: '九江'
          }, {
            name: '九江',
            value: 200
          }],

          [{
            name: '九江'
          }, {
            name: '长沙',
            value: 95
          }],
          [{
            name: '九江'
          }, {
            name: '武汉',
            value: 30
          }],
          [{
            name: '九江'
          }, {
            name: '南昌',
            value: 20
          }],
          [{
            name: '九江'
          }, {
            name: '合肥',
            value: 70
          }],
          [{
            name: '九江'
          }, {
            name: '南京',
            value: 60
          }],
          [{
            name: '九江'
          }, {
            name: '福州',
            value: 50
          }],
          [{
            name: '九江'
          }, {
            name: '上海',
            value: 100
          }],
          [{
            name: '九江'
          }, {
            name: '深圳',
            value: 100
          }],

        ];

        var GZData = [
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '新疆玛纳斯基地',
            value: 200
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '  ',
            value: 90
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: ' ',
            value: 40
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '呼和浩特',
            value: 90
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '昆明',
            value: 40
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '成都',
            value: 10
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '兰州',
            value: 95
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '银川',
            value: 90
          }],
          [{
            name: '新疆玛纳斯基地'
          }, {
            name: '西宁',
            value: 80
          }],

        ];

        var planePath = 'path://M.6,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705';

        var convertData = function (data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = geoCoordMap[dataItem[0].name];
            var toCoord = geoCoordMap[dataItem[1].name];
            if (fromCoord && toCoord) {
              res.push([{
                coord: fromCoord
              }, {
                coord: toCoord
              }]);
            }
          }
          return res;
        };

        var color = ['#3ed4ff', '#ffa022', '#a6c84c'];
        var series = [];
        [
          ['新乡', BJData],
          ['九江', SHData],
          ['新疆', GZData]
        ].forEach(function (item, i) {
          series.push({
            name: item[0] + ' Top10',
            type: 'lines',
            zlevel: 1,
            effect: {
              show: true,
              period: 6,
              trailLength: 0.7,
              color: '#fff',
              symbolSize: 3
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 0,
                curveness: 0.2
              }
            },
            data: convertData(item[1])
          }, {
            name: item[0] + ' Top10',
            type: 'lines',
            zlevel: 2,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: planePath,
              symbolSize: 15
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 1,
                opacity: 0.4,
                curveness: 0.2
              }
            },
            data: convertData(item[1])
          }, {
            name: item[0] + ' Top10',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}'
              }
            },
            symbolSize: function (val) {
              return val[2] / 8;
            },
            itemStyle: {
              normal: {
                color: color[i]
              }
            },
            data: item[1].map(function (dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
              };
            })
          });
        });
        console.log(22);

        var option = {
          backgroundColor: '#080a20',
          title: {
            left: 'left',
            textStyle: {
              color: '#fff'
            }
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            top: 'bottom',
            left: 'right',
            data: ['北京 Top10', '上海 Top10', '广州 Top10'],
            textStyle: {
              color: '#fff'
            },
            selectedMode: 'single'
          },
          geo: {
            map: 'china',
            zoom: 1.2,
            label: {
              emphasis: {
                show: false
              }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#142957',
                borderColor: '#0692a4'
              },
              emphasis: {
                areaColor: '#0b1c2d'
              }
            },
          },
          series: series
        };

        this.$refs.vchart6.setData(option, true);

        return
      }
    },
  };
</script>
<style>
 .el-progress-bar .el-progress-bar__outer{
    background: #112774 !important; 
  }
</style>
<style scoped  >

  .time {
    position: absolute;
    right: .120px;
    margin-top: 30px;
    font-size: .105px;
    display: block;
    color: #fff;
    margin-right: 30px;
  }

  .chart_box {
    display: flex;
  }

  .chart_box>.pare {
    flex: 1;
  }

  .chart_box>.progress {
    width: 40%;
  }
  .progress2 .text{
    display: flex;
      justify-content: space-between;
      margin-bottom: .225px;
      color: #fff;
  }
  .progress2 .text span{
    color: #fff;
  }
  .chart_box .progress2 {
    width: 40%;
    .el-progress {
      margin-bottom: .75px;
    }
  }

  .chart_box .progress .text {
    display: flex;
    justify-content: space-between;
    margin-bottom: .45px;
  }

  .chart_box .progress .text span {
    color: #fff;
  }

  .chart_box .progress .el-progress {
    margin-bottom: 19.5px;
  }

  .bottom_box {
    display: flex;
    overflow: hidden;
    padding: 0 12.495px;
    margin-bottom: 40px;
  }

  .bottom_box .panel {
    flex: 1;
    margin-right: 12.495px;
  }

  .bottom_box .panel:nth-child(2) {
    margin-right: 0;
  }

  .bodyed {
    position: relative;
    display: block;
    line-height: 1.15;
    font-size: 7.5px;
    margin: 0;
    padding: 0;
    background-repeat: no-repeat;
    background-position: 0 0 / cover;
    background-color: #101129; 
    padding-bottom: 60px;
  }

  * {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  .viewport {
    /* 限定大小 */
    min-width: 1024px;
    max-width: 1920px;
    margin: 0 auto;
    background: url('../../../public/static/image/demo/assets/logo.png') no-repeat 0 0 / contain;
    display: flex;
    padding: 55.005px 12.495px 0;
  }

  .column {
    flex: 3;
    position: relative;
  }

  .column:nth-child(2) {
    flex: 4;
    margin: 19.995px 12.495px 0;
  }

  .panel {
    /* 边框 */
    box-sizing: border-box;
    border: 2px solid red;
    border-image: url('../../../public/static/image/demo/assets/border.png') 51 38 21 132;
    border-width: 31.875px 23.745px 13.125px 82.5px;
    position: relative;
    margin-bottom: 12.495px;
  }

  .panel_box {
    width: 30%;
    height: 49.5px;
    padding-top: .45px;
    box-sizing: border-box;
    border: solid 1px #093552;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px 23px #03729724 inset;
  }

  .panel .inner {
    /* 装内容 */
    /* height:60px;*/
    position: absolute;
    top: -31.875px;
    right: -23.745px;
    bottom: -13.125px;
    left: -82.5px;
    padding: 15px 22.5px;
    display: flex;
    flex-direction: column;
  }

  .panel h3 {
    font-size: 12.495px;
    color: #fff;
    text-align: center;
  }

  /* 概览区域 */
  .overview {
    height: 68.745px;
  }

  .overview .inner {
    display: flex;
    justify-content: space-between;
  }

  .overview h4 {
    font-size: .135px;
    padding-left: 3px;
    color: #fff;
    margin-bottom: 4.995px
  }

  .overview span {
    font-size: 13.005px;
    color: #4c9bfd;
    margin-bottom: .45px;
  }

  /* 监控 */
  .monitor {
    height: 180px;
  }

  .monitor .inner {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
  }

  .monitor .tabs {
    padding: 0 22.5px;
    margin-bottom: 11.25px;
  }

  .monitor .tabs a {
    color: #1950c4;
    font-size: 11.25px;
    padding: 0 16.875px;
  }

  .monitor .tabs a:first-child {
    border-right: 1.245px solid #00f2f1;
    padding-left: 0;
  }

  .monitor .tabs a.active {
    color: #fff;
  }

  .monitor .content {
    flex: 1;
    display: none;
    position: relative;
  }

  .monitor .head {
    background: rgba(255, 255, 255, 0.1);
    font-size: 8.745px;
    padding: 7.5px 22.5px;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;
    line-height: 1.05;
  }

  .monitor .col:nth-child(1) {
    width: 78px;
  }

  .monitor .col:nth-child(2) {
    flex: 1;
    /* 不换行 一行省略*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .monitor .col:nth-child(3) {
    width: 68px; 
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  .monitor .row {
    line-height: 1.05;
    padding: 7.5px 22.5px;
    color: #61a8ff;
    font-size: 7.5px;
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  .monitor .marquee-view {
    position: absolute;
    top: .90px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }

  .monitor .row {
    line-height: 1.05;
    padding: 7.5px 22.5px;
    color: #61a8ff;
    font-size: 7.5px;
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .monitor .row:hover {
    color: #68d8ff;
    background: rgba(255, 255, 255, 0.1);
  }

  .monitor .row:hover .fa-arrow-up {
    opacity: 1;
  }

  .monitor .fa-arrow-up {
    position: absolute;
    left: 9.6px;
    opacity: 0;
  }

  /* ------------------------------------------------------------动画 */
  @keyframes row {
    0% {}

    100% {
      transform: translateY(-50%);
    }
  }

  /* 调用动画 */
  .monitor .marquee {
    /* //infinite永久调用动画 */
    animation: row 10s linear infinite;
  }

  /*鼠标划入 停止动画 */
  .monitor .marquee:hover {
    animation-play-state: paused;
  }

  /* 点位 */
  .point {
    height: 180px;
  }

  .point .chart {
    display: flex;
    justify-content: space-between;
  }

  .point .pie {
    width: 100%;
    height: 147px;
    margin-left: -6px;
  }

  .point .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../../public/static/image/demo/assets/rect.png');
    background-size: cover;
  }

  .point h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }

  .point span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }

  /* 地图 */
  .map {
    height: 97%;
    margin-bottom: 12.495px;
    display: flex;
    flex-direction: column;
  }

  .map h3 {
    line-height: 1;
    padding: 10.005px 0;
    margin: 0;
    font-size: 12.495px;
    color: #fff;
  }

  .map .fa-cube {
    color: #68d8fe;
  }

  .map .chart {
    flex: 1;
    background-color: rgba(255, 255, 255, 0.05);
  }

  .map .geo {
    width: 100%;
    height: 100%;
  }

  /* 用户模块 */
  .users {
    height: 180px;
    display: flex;
  }

  .users .chart {
    display: flex;
    margin-top: .75px;
    height: 100%;
  }

  .users .bar {
    width: 367.5px;
    height: 135px;
  }

  .users .data {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 105px;
    padding: 22.5px 18.75px;
    box-sizing: border-box;
    background-image: url('../../../public/static/image/demo/assets/rect.png');
    background-size: cover;
  }

  .users h4 {
    margin-bottom: 7.5px;
    font-size: 17.505px;
    color: #fff;
  }

  .users span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }

  /* 订单 */
  .order {
    height: 92.505px;
  }

  .order .filter {
    display: flex;
  }

  .order .filter a {
    display: block;
    height: 11.25px;
    line-height: 1;
    padding: 0 11.25px;
    color: #1950c4;
    font-size: 11.25px;
    border-right: 1.245px solid #00f2f1;
  }

  .order .filter a:first-child {
    padding-left: 0;
  }

  .order .filter a:last-child {
    border-right: none;
  }

  .order .filter a.active {
    color: #fff;
    font-size: 12.495px;
  }

  .order .data {
    display: flex;
    margin-top: 12.495px;
  }

  .order .item {
    width: 50%;
  }

  .order h4 {
    font-size: 17.505px;
    color: #fff;
    margin-bottom: 6.255px;
  }

  .order span {
    display: block;
    color: #4c9bfd;
    font-size: 10.005px;
  }

  /* 销售区域 */
  .sales {
    height: 180px;
  }

  .sales .caption {
    display: flex;
    line-height: 1;
  }

  .sales h3 {
    height: 11.25px;
  }

  .sales .chart {
    flex: 1;
    padding-top: 9px;
    position: relative;
  }

  .sales .label {
    position: absolute;
    left: 26.25px;
    top: 11.25px;
    color: #4996f5;
    font-size: 8.745px;
  }

  .sales .line {
    width: 100%;
    height: 100%;
  }

  /* 渠道区块 */
  .wrap {
    display: flex;
  }

  .channel,
  .quarter {
    flex: 1;
    height: 145.005px;
  }

  .channel {
    margin-right: 12.495px;
  }

  .channel .data {
    overflow: hidden;
  }

  .channel .item {
    margin-top: 12.75px;
  }

  .channel .item:first-child {
    float: left;
  }

  .channel .item:last-child {
    float: right;
  }

  .channel h4 {
    color: #fff;
    font-size: 19.995px;
    margin-bottom: 3px;
  }

  .channel small {
    font-size: 50%;
  }

  .channel span {
    display: block;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 季度区块 */
  .quarter .inner {
    display: flex;
    flex-direction: column;
    margin: 0 -3.75px;
  }

  .quarter .chart {
    flex: 1;
    padding-top: 11.25px;
  }

  .quarter .box {
    position: relative;
  }

  .quarter .label {
    transform: translate(-50%, -30%);
    color: #fff;
    font-size: 18.75px;
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .quarter .label small {
    font-size: 50%;
  }

  .quarter .gauge {
    height: 52.5px;
  }

  .quarter .data {
    display: flex;
    justify-content: space-between;
  }

  .quarter .item {
    width: 50%;
  }

  .quarter h4 {
    color: #fff;
    font-size: 15px;
    margin-bottom: 6px;
  }

  .quarter span {
    display: block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #4c9bfd;
    font-size: 8.745px;
  }

  /* 排行榜 */
  .top {
    height: 177px;
  }

  .top .inner {
    display: flex;
  }

  .top .all {
    display: flex;
    flex-direction: column;
    width: 105px;
    color: #4c9bfd;
    font-size: 9px;
    vertical-align: middle;
  }

  .top .all i {
    font-size: 21px;
  }

  .top .all ul {
    padding-left: 7.5px;
    margin-top: 7.5px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .top .all li {
    overflow: hidden;
  }

  .top .all [class^="icon-"] {
    font-size: 22.5px;
    vertical-align: middle;
    margin-right: 7.5px;
  }

  .top .province {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #fff;
  }

  .top .province i {
    padding: 0 7.5px;
    margin-top: 3.12px;
    float: right;
    font-style: normal;
    font-size: 8.745px;
    color: #0bace6;
  }

  .top .province s {
    display: inline-block;
    transform: scale(0.8);
    text-decoration: none;
  }

  .top .province .fa-arrow-up {
    color: #dc3c33;
  }

  .top .province .fa-arrow-down {
    color: #36be90;
  }

  .top .province .data {
    flex: 1;
    display: flex;
    margin-top: 9px;
  }

  .top .province ul {
    flex: 1;
    line-height: 1;
    margin-bottom: 3.75px;
  }

  .top .province ul li {
    display: flex;
    justify-content: space-between;
  }

  .top .province ul span {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .top .province ul.sup {
    font-size: 8.745px;
  }

  .top .province ul.sup li {
    color: #4995f4;
    padding: 7.5px;
  }

  .top .province ul.sup li.active {
    color: #a3c6f2;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 7.5px;
    background-color: rgba(10, 67, 188, 0.2);
  }

  .top .province ul.sub li {
    color: #52ffff;
    padding: 6.255px 9px;
  }

  .clock {
    position: absolute;
    top: -22.5px;
    right: 25.005px;
    font-size: 12.495px;
    color: #0bace6;
  }

  .clock i {
    margin-right: 5px;
    font-size: 12.495px;
  }

  @media screen and (max-width:1600px) {
    .top span {
      transform: scale(0.9);
    }

    .top .province ul.sup li {
      padding: 6px 7.5px;
    }

    .top .province ul.sub li {
      padding: 3.45px 7.5px;
    }

    .quarter span {
      transform: scale(0.9);
    }
  }
</style>